/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} bookingsPaymentsPaymentMethodPopupChooseOfflineParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {GUID} biToken - null
* @property {string} serviceId - -
* @property {string} type - {class\ind}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU >  payments>payment method popup>choose offline. Evid: 555.
 * Event description: http://prntscr.com/ehwro8.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * biToken - Type: guid.
 *
 * serviceId - Type: string. Desc: -
 *
 * type - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid.
 * @param {bookingsPaymentsPaymentMethodPopupChooseOfflineParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsPaymentsPaymentMethodPopupChooseOffline = function (params) {
    return { evid: 555, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsFitMemberAppUpcomingWidgetLoadedParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {GUID} biToken - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > Member Mobile App > fit member app -> upcoming widget -> loaded. Evid: 590.
 * Event description: the bookings upcoming widget was loaded.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * biToken - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {bookingsFitMemberAppUpcomingWidgetLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsFitMemberAppUpcomingWidgetLoaded = function (params) {
    return { evid: 590, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsOneAppApplyPromoCodeParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - business_id
* @property {GUID} contactId - null
* @property {GUID} couponId - coupon_id
* @property {boolean} isEdited - 0 if the user enters the code for the first time, 1 if it is edited
* @property {GUID} biToken - msid
* @property {string} type - service type {class\ind\course}
* @property {string} validValue - {ok/expired/invalid}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > Member Mobile App >  OneApp --> Apply promo code. Evid: 575.
 * Event description: Apply promo code after entering it/click "Save".

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: business_id
 *
 * contactId - Type: guid.
 *
 * couponId - Type: guid. Desc: coupon_id
 *
 * isEdited - Type: bool. Desc: 0 if the user enters the code for the first time, 1 if it is edited
 *
 * biToken - Type: guid. Desc: msid
 *
 * type - Type: string. Desc: service type {class\ind\course}
 *
 * validValue - Type: string. Desc: {ok/expired/invalid}
 *
 * visitor_id - Type: guid.
 * @param {bookingsOneAppApplyPromoCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsOneAppApplyPromoCode = function (params) {
    return { evid: 575, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsFitMemberAppUpcomingWidgetClickOnItemParams
* @property {string} actionName - []
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {GUID} biToken - null
* @property {string} section - upcoming/previous/see all
* @property {string} serviceId - service id
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > Member Mobile App > fit member app -> upcoming widget -> click on item. Evid: 591.
 * Event description: click on item in upcoming widget.

 * actionName - Type: string. Desc: []
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * biToken - Type: guid.
 *
 * section - Type: string. Desc: upcoming/previous/see all
 *
 * serviceId - Type: string. Desc: service id
 *
 * visitor_id - Type: guid.
 * @param {bookingsFitMemberAppUpcomingWidgetClickOnItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsFitMemberAppUpcomingWidgetClickOnItem = function (params) {
    return { evid: 591, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsUouBookingsFormClicksParams
* @property {string} action - what was clicked
* @property {string} formId - --
* @property {string} bookingsPlatform - -
* @property {GUID} businessId - -
* @property {GUID} contactId - -
* @property {GUID} biToken - msid
* @property {string} referralInfo - -
* @property {string} serviceId - service id
* @property {string} value - which payment was sent
* @property {GUID} visitor_id - -
**/
/**
 * Name: Bookings > UoU > Bookings Form > clicks. Evid: 1052.
 * Event description: when uou makes interaction with the form.

 * action - Type: string. Desc: what was clicked
 *
 * formId - Type: string. Desc: --
 *
 * bookingsPlatform - Type: string. Desc: -
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid. Desc: -
 *
 * biToken - Type: guid. Desc: msid
 *
 * referralInfo - Type: string. Desc: -
 *
 * serviceId - Type: string. Desc: service id
 *
 * value - Type: string. Desc: which payment was sent
 *
 * visitor_id - Type: guid. Desc: -
 * @param {bookingsUouBookingsFormClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsUouBookingsFormClicks = function (params) {
    return { evid: 1052, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsDeletePromoCodeParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - business_id
* @property {GUID} contactId - contact_id
* @property {string} couponId - coupon_id
* @property {string} couponName - coupon code
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - is_preview
* @property {GUID} biToken - msid
* @property {string} serviceType - service type {class\ind\course}
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: Bookings > UoU > Payments > Delete Promo Code. Evid: 573.
 * Event description: Delete promo code - click on the garbage icon.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: business_id
 *
 * contactId - Type: guid. Desc: contact_id
 *
 * couponId - Type: string. Desc: coupon_id
 *
 * couponName - Type: string. Desc: coupon code
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool. Desc: is_preview
 *
 * biToken - Type: guid. Desc: msid
 *
 * serviceType - Type: string. Desc: service type {class\ind\course}
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {bookingsDeletePromoCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsDeletePromoCode = function (params) {
    return { evid: 573, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsClickOnEnterPromoCodeParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - business_id
* @property {GUID} contactId - contact_id
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - is_preview
* @property {GUID} biToken - msid
* @property {string} type - {class\ind\course}
* @property {string} serviceType - {class\ind\course}
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: Bookings > UoU > Payments >  Member Click On "Enter promo code". Evid: 571.
 * Event description: Click on enter promo code from contact info page.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: business_id
 *
 * contactId - Type: guid. Desc: contact_id
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool. Desc: is_preview
 *
 * biToken - Type: guid. Desc: msid
 *
 * type - Type: string. Desc: {class\ind\course}
 *
 * serviceType - Type: string. Desc: {class\ind\course}
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {bookingsClickOnEnterPromoCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsClickOnEnterPromoCode = function (params) {
    return { evid: 571, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsReturnFromLoginParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} firstLogin - null
* @property {boolean} is_over_editor - null
* @property {boolean} is_owner - null
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} pageName - null
* @property {boolean} success - null
* @property {GUID} visitor_id - null
* @property {GUID} visitorIdAnon - the visitor_id when the visitor is anonymous- not logged in
**/
/**
 * Name: Bookings > UoU > Return From Login. Evid: 543.
 * Event description: return from login.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * firstLogin - Type: bool.
 *
 * is_over_editor - Type: bool.
 *
 * is_owner - Type: bool.
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * pageName - Type: string.
 *
 * success - Type: bool.
 *
 * visitor_id - Type: guid.
 *
 * visitorIdAnon - Type: guid. Desc: the visitor_id when the visitor is anonymous- not logged in
 * @param {bookingsReturnFromLoginParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsReturnFromLogin = function (params) {
    return { evid: 543, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsChangeParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} section - {booking_summary,contact_info}
* @property {GUID} visitor_id - null
**/
/**
 * Name: NO DATA - bookings > change. Evid: 508.
 * Event description: Cancelled.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * section - Type: string. Desc: {booking_summary,contact_info}
 *
 * visitor_id - Type: guid.
 * @param {bookingsChangeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsChange = function (params) {
    return { evid: 508, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsOpenDatesCalendarParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: NO DATA - Bookings --> OneApp --> click on the 3 dots (edit a session). Evid: 503.
 * Event description: Click on the 3 dots from an appointment or a class instance in order to change it.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {bookingsOpenDatesCalendarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsOpenDatesCalendar = function (params) {
    return { evid: 503, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsServicePageSeeAllServicesClickParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - null
* @property {string} selection - {course_schedule}
* @property {string} serviceId - service_id
* @property {string} type - course.class
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Book Flow > Service List > See All Sessions. Evid: 556.
 * Event description: course - see all schedules.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid.
 *
 * selection - Type: string. Desc: {course_schedule}
 *
 * serviceId - Type: string. Desc: service_id
 *
 * type - Type: string. Desc: course.class
 *
 * visitor_id - Type: guid.
 * @param {bookingsServicePageSeeAllServicesClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsServicePageSeeAllServicesClick = function (params) {
    return { evid: 556, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsLoginUserAccountPersonalInfoSaveClickParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {boolean} nameChanged - T= name changed
* @property {boolean} phoneChanged - T= phone changed
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU >  Member Area > My Account  > save.click. Evid: 550.
 * Event description: on the user account (myaccount) page > personal info tab - click on save http://prntscr.com/dqa5g6.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * nameChanged - Type: bool. Desc: T= name changed
 *
 * phoneChanged - Type: bool. Desc: T= phone changed
 *
 * visitor_id - Type: guid.
 * @param {bookingsLoginUserAccountPersonalInfoSaveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsLoginUserAccountPersonalInfoSaveClick = function (params) {
    return { evid: 550, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsCalendarChooseStaffMemberParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {string} loaction - business/custom
* @property {GUID} locationGuid - location_guid
* @property {GUID} biToken - null
* @property {GUID} staffId - staff_id
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU >  Calendar > Choose Staff Member. Evid: 530.
 * Event description: sent when the UoU choose a staff member to provide the service in the tooltip (only when all staff is selected in dropdown filter).

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * loaction - Type: string. Desc: business/custom
 *
 * locationGuid - Type: guid. Desc: location_guid
 *
 * biToken - Type: guid.
 *
 * staffId - Type: guid. Desc: staff_id
 *
 * visitor_id - Type: guid.
 * @param {bookingsCalendarChooseStaffMemberParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsCalendarChooseStaffMember = function (params) {
    return { evid: 530, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsChooseADateOnCalendarParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - business_id
* @property {GUID} contactId - contact_id
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - msid
* @property {string} platform - {mobile,pc}
* @property {boolean} reschedule - T=is reschedule F= regular
* @property {GUID} site_member_id - site_member_id
* @property {string} type - {class\ind}
* @property {GUID} visitor_id - visitor_id
**/
/**
 * Name: Bookings > UoU > Calendar > Choose a Date On Calendar. Evid: 570.
 * Event description: choose a date on the calendar.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: business_id
 *
 * contactId - Type: guid. Desc: contact_id
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid. Desc: msid
 *
 * platform - Type: string. Desc: {mobile,pc}
 *
 * reschedule - Type: bool. Desc: T=is reschedule F= regular
 *
 * site_member_id - Type: guid. Desc: site_member_id
 *
 * type - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid. Desc: visitor_id
 * @param {bookingsChooseADateOnCalendarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsChooseADateOnCalendar = function (params) {
    return { evid: 570, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsBookingsFormClickParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - -
* @property {GUID} contactId - null
* @property {string} fieldName - field that clicked
* @property {number} formId - -
* @property {GUID} biToken - -
* @property {GUID} serviceId - service id
* @property {GUID} visitor_id - -
**/
/**
 * Name: Bookings > UoU > Bookings Form > Click - No data. Evid: 608.
 * Event description: When clicking on a field in booking form.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid.
 *
 * fieldName - Type: string. Desc: field that clicked
 *
 * formId - Type: numeric. Desc: -
 *
 * biToken - Type: guid. Desc: -
 *
 * serviceId - Type: guid. Desc: service id
 *
 * visitor_id - Type: guid. Desc: -
 * @param {bookingsBookingsFormClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsBookingsFormClick = function (params) {
    return { evid: 608, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsPickDatesMobileParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - is_over_editor
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - null
* @property {string} pid - page_id
* @property {GUID} visitor_id - null
**/
/**
 * Name: NO DATA - bookings > pick dates mobile. Evid: 516.
 * Event description: NEED TO DELETE - 506 instead.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: is_over_editor
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid.
 *
 * pid - Type: string. Desc: page_id
 *
 * visitor_id - Type: guid.
 * @param {bookingsPickDatesMobileParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsPickDatesMobile = function (params) {
    return { evid: 516, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsLoginUserAccountSeeAllServicesClickParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} referralInfo - on what tab the button was clicked -{appointments, personal info}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Member Area > My Bookings Click. Evid: 549.
 * Event description: click on the" see all services" button on the user account page - http://prntscr.com/dqa0rl.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * referralInfo - Type: string. Desc: on what tab the button was clicked -{appointments, personal info}
 *
 * visitor_id - Type: guid.
 * @param {bookingsLoginUserAccountSeeAllServicesClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsLoginUserAccountSeeAllServicesClick = function (params) {
    return { evid: 549, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsServicesListViewParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} pid - null = web. for oneapp = {schedule_tab, services_tab}
* @property {string} type - group\private\both
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Book Flow > Service List View. Evid: 515.
 * Event description: app page is viewed on site- services page opened.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * pid - Type: string. Desc: null = web. for oneapp = {schedule_tab, services_tab}
 *
 * type - Type: string. Desc: group\private\both
 *
 * visitor_id - Type: guid.
 * @param {bookingsServicesListViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsServicesListView = function (params) {
    return { evid: 515, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsCancellationPolicyParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} type - {class\ind}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Book Flow > Cancellation Policy. Evid: 521.
 * Event description: cancellation policy- Visitor.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * type - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid.
 * @param {bookingsCancellationPolicyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsCancellationPolicy = function (params) {
    return { evid: 521, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsConfirmAnotherParticipantRemovalPhase2Params
* @property {boolean} approve - T=approved, F= canceled
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - null
* @property {string} serviceId - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: NO DATA - bookings > confirm another participant removal - phase 2. Evid: 537.
 * Event description: approve\not approve another participant removal
http://prntscr.com/bjzjty.

 * approve - Type: bool. Desc: T=approved, F= canceled
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid.
 *
 * serviceId - Type: string. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsConfirmAnotherParticipantRemovalPhase2Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsConfirmAnotherParticipantRemovalPhase2 = function (params) {
    return { evid: 537, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsAppointmentBookedParams
* @property {number} amountPaid - Price paid by user, multiplied by num_participants, after discounts. For offline = 0. Multiplied by 10,000
* @property {string} bookingId - null
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - booking_id = order_id in evid 16:1010
* @property {string} catId - null
* @property {GUID} contactId - null
* @property {GUID} couponId - coupon_id
* @property {boolean} courseStartedBeforeBook - T/F
* @property {string} currency - service booked currency
* @property {number} depositAmount - Multiplied by 10,000
* @property {boolean} is_coupon - 0- if coupon not used. 1 if coupon is applied.
* @property {boolean} is_membership - 1 or 0
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {boolean} isPendingApproval - is pending approval service
* @property {boolean} isPreview - null
* @property {boolean} logged - T= logged in, F= not
* @property {string} mobileSource - -
* @property {GUID} biToken - null
* @property {number} numParticipants - default=1
* @property {number} originalPrice - Not relevant!
* @property {string} paymentMethod - {offline,online, paid_plan_limited, paid_plan_unlimited}
* @property {string} platform - {mobile,pc}
* @property {number} price - Original Service Price, before discounts (NOT multiplied by num_participants). Multiplied by 10,000
* @property {string} price_selection - -
* @property {string} referal_info - for one-click book (oneapp) = "agenda", else null
* @property {string} serviceId - -
* @property {string} sessionId - --
* @property {number} totalPrice - Price multiplied by num_participants, after discounts. Multiplied by 10,000
* @property {string} type - {class\ind\course}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU >  Session Booked. Evid: 526.
 * Event description: Appointment is booked (offline or online payment ).

 * amountPaid - Type: numeric. Desc: Price paid by user, multiplied by num_participants, after discounts. For offline = 0. Multiplied by 10,000
 *
 * bookingId - Type: string.
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: booking_id = order_id in evid 16:1010
 *
 * catId - Type: string.
 *
 * contactId - Type: guid.
 *
 * couponId - Type: guid. Desc: coupon_id
 *
 * courseStartedBeforeBook - Type: bool. Desc: T/F
 *
 * currency - Type: string. Desc: service booked currency
 *
 * depositAmount - Type: numeric. Desc: Multiplied by 10,000
 *
 * is_coupon - Type: bool. Desc: 0- if coupon not used. 1 if coupon is applied.
 *
 * is_membership - Type: bool. Desc: 1 or 0
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPendingApproval - Type: bool. Desc: is pending approval service
 *
 * isPreview - Type: bool.
 *
 * logged - Type: bool. Desc: T= logged in, F= not
 *
 * mobileSource - Type: string. Desc: -
 *
 * biToken - Type: guid.
 *
 * numParticipants - Type: numeric. Desc: default=1
 *
 * originalPrice - Type: numeric. Desc: Not relevant!
 *
 * paymentMethod - Type: string. Desc: {offline,online, paid_plan_limited, paid_plan_unlimited}
 *
 * platform - Type: string. Desc: {mobile,pc}
 *
 * price - Type: numeric. Desc: Original Service Price, before discounts (NOT multiplied by num_participants). Multiplied by 10,000
 *
 * price_selection - Type: string. Desc: -
 *
 * referal_info - Type: string. Desc: for one-click book (oneapp) = "agenda", else null
 *
 * serviceId - Type: string. Desc: -
 *
 * sessionId - Type: string. Desc: --
 *
 * totalPrice - Type: numeric. Desc: Price multiplied by num_participants, after discounts. Multiplied by 10,000
 *
 * type - Type: string. Desc: {class\ind\course}
 *
 * visitor_id - Type: guid.
 * @param {bookingsAppointmentBookedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsAppointmentBooked = function (params) {
    return { evid: 526, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsDownloadClickForUouParams
* @property {string} additionalInfo - CTA description {waitlist_flow_download_oa}
* @property {string} bookingId - -
* @property {string} bookingsPlatform - -
* @property {GUID} businessId - -
* @property {string} businessProperties - -
* @property {GUID} contactId - -
* @property {string} selectedFilters - -
* @property {boolean} is_over_editor - is_over_editor
* @property {boolean} isPremium - -
* @property {boolean} isPreview - 1 if this is preview mode, 0 if live site
* @property {GUID} biToken - -
* @property {string} pageName - -
* @property {string} premiumStatus - {free,non_bookings_premium}
* @property {string} referral_info - {Payments/Booking/Waitlist}
* @property {string} referralInfo - -
* @property {string} selectedDate - -
* @property {string} serviceId - -
* @property {string} serviceProperties - -
* @property {string} selectedTimezone - -
* @property {string} type - Service type {appointment, class, course}
* @property {string} serviceType - -
* @property {GUID} visitor_id - -
**/
/**
 * Name: Bookings > UoU > Book Flow > Download Click For UoU. Evid: 582.
 * Event description: For any download CTA clicked by UoU or owner only on preview mode or live..

 * additionalInfo - Type: string. Desc: CTA description {waitlist_flow_download_oa}
 *
 * bookingId - Type: string. Desc: -
 *
 * bookingsPlatform - Type: string. Desc: -
 *
 * businessId - Type: guid. Desc: -
 *
 * businessProperties - Type: string. Desc: -
 *
 * contactId - Type: guid. Desc: -
 *
 * selectedFilters - Type: string. Desc: -
 *
 * is_over_editor - Type: bool. Desc: is_over_editor
 *
 * isPremium - Type: bool. Desc: -
 *
 * isPreview - Type: bool. Desc: 1 if this is preview mode, 0 if live site
 *
 * biToken - Type: guid. Desc: -
 *
 * pageName - Type: string. Desc: -
 *
 * premiumStatus - Type: string. Desc: {free,non_bookings_premium}
 *
 * referral_info - Type: string. Desc: {Payments/Booking/Waitlist}
 *
 * referralInfo - Type: string. Desc: -
 *
 * selectedDate - Type: string. Desc: -
 *
 * serviceId - Type: string. Desc: -
 *
 * serviceProperties - Type: string. Desc: -
 *
 * selectedTimezone - Type: string. Desc: -
 *
 * type - Type: string. Desc: Service type {appointment, class, course}
 *
 * serviceType - Type: string. Desc: -
 *
 * visitor_id - Type: guid. Desc: -
 * @param {bookingsDownloadClickForUouParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsDownloadClickForUou = function (params) {
    return { evid: 582, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsMembersAreaMyBookingsJoinVcSessionParams
* @property {string} bookingsPlatform - -
* @property {GUID} businessId - -
* @property {GUID} contactId - -
* @property {string} current_platform - {ZOOM/CUSTOM}
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - -
* @property {GUID} session_id - session_id
* @property {GUID} visitor_id - -
**/
/**
 * Name: Bookings > UoU > Members area (My Bookings) > Join VC Session. Evid: 592.
 * Event description: sent when the member chooses to join a vc session.

 * bookingsPlatform - Type: string. Desc: -
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid. Desc: -
 *
 * current_platform - Type: string. Desc: {ZOOM/CUSTOM}
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid. Desc: -
 *
 * session_id - Type: guid. Desc: session_id
 *
 * visitor_id - Type: guid. Desc: -
 * @param {bookingsMembersAreaMyBookingsJoinVcSessionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsMembersAreaMyBookingsJoinVcSession = function (params) {
    return { evid: 592, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsMoveDatesCalendarParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {string} direction - {backward,farward}
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} platform - {mobile,pc}
* @property {string} type - {week,month}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > My Bookings >  Reschedule a Session. Evid: 504.
 * Event description: move Dates calendar - also available from OneApp (with roles = owner, since uou don't have this reschedule flow on the app).

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * direction - Type: string. Desc: {backward,farward}
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * platform - Type: string. Desc: {mobile,pc}
 *
 * type - Type: string. Desc: {week,month}
 *
 * visitor_id - Type: guid.
 * @param {bookingsMoveDatesCalendarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsMoveDatesCalendar = function (params) {
    return { evid: 504, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsClickLoadMoreHoursParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - business_id
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - is_over_editor
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - is_preview
* @property {GUID} biToken - null
* @property {string} platform - {mobile,pc}
* @property {boolean} reschedule - T=is reschedule F= regular
* @property {string} type - {class\ind}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Calendar > Click "load more hours". Evid: 578.
 * Event description: click in the "load more hours" option in the calendar (currently only available from mobile).

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: business_id
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: is_over_editor
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool. Desc: is_preview
 *
 * biToken - Type: guid.
 *
 * platform - Type: string. Desc: {mobile,pc}
 *
 * reschedule - Type: bool. Desc: T=is reschedule F= regular
 *
 * type - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid.
 * @param {bookingsClickLoadMoreHoursParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsClickLoadMoreHours = function (params) {
    return { evid: 578, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsCalendarDatePickerLoadParams
* @property {string} bookingId - If reschedule then value is not null
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - business_id
* @property {string} businessProperties - null
* @property {GUID} contactId - contact_id
* @property {string} dateAvailability - -
* @property {string} defaultDateAtFirstLoad - null
* @property {string} selectedFilters - null
* @property {boolean} isPremium - null
* @property {string} layout - weekly, daily_month
* @property {GUID} biToken - msid
* @property {string} pageName - -
* @property {string} referralInfo - service_list_widget' | 'service_details_widget' | 'members_area_reschedule' | 'members_area_book_again'
* @property {string} selectedDate - default date
* @property {string} selectedRange - selected range shown
* @property {string} serviceId - service_id
* @property {string} serviceProperties - null
* @property {string} selectedTimezone - null
* @property {string} triggeredBy - -
* @property {string} serviceType - service type
* @property {string} visibleRange - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > calendar > date picker load. Evid: 594.
 * Event description: calendar date picker load.

 * bookingId - Type: string. Desc: If reschedule then value is not null
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: business_id
 *
 * businessProperties - Type: string.
 *
 * contactId - Type: guid. Desc: contact_id
 *
 * dateAvailability - Type: string. Desc: -
 *
 * defaultDateAtFirstLoad - Type: string.
 *
 * selectedFilters - Type: string.
 *
 * isPremium - Type: bool.
 *
 * layout - Type: string. Desc: weekly, daily_month
 *
 * biToken - Type: guid. Desc: msid
 *
 * pageName - Type: string. Desc: -
 *
 * referralInfo - Type: string. Desc: service_list_widget' | 'service_details_widget' | 'members_area_reschedule' | 'members_area_book_again'
 *
 * selectedDate - Type: string. Desc: default date
 *
 * selectedRange - Type: string. Desc: selected range shown
 *
 * serviceId - Type: string. Desc: service_id
 *
 * serviceProperties - Type: string.
 *
 * selectedTimezone - Type: string.
 *
 * triggeredBy - Type: string. Desc: -
 *
 * serviceType - Type: string. Desc: service type
 *
 * visibleRange - Type: string. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsCalendarDatePickerLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsCalendarDatePickerLoad = function (params) {
    return { evid: 594, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsReturnFromExternalPaymentProviderAfterOnlinePaymentParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {string} currency - NOT SENT
* @property {number} depositAmount - NOT SENT
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - null
* @property {string} paymentProvider - {paypal, stripe}
* @property {string} platform - {mobile,pc}
* @property {number} price - multiplied by 10,000
* @property {string} serviceId - -
* @property {boolean} success - -
* @property {string} type - {class\ind}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > return from external payment provider after online payment. Evid: 519.
 * Event description: return after paypal connect.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * currency - Type: string. Desc: NOT SENT
 *
 * depositAmount - Type: numeric. Desc: NOT SENT
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid.
 *
 * paymentProvider - Type: string. Desc: {paypal, stripe}
 *
 * platform - Type: string. Desc: {mobile,pc}
 *
 * price - Type: numeric. Desc: multiplied by 10,000
 *
 * serviceId - Type: string. Desc: -
 *
 * success - Type: bool. Desc: -
 *
 * type - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid.
 * @param {bookingsReturnFromExternalPaymentProviderAfterOnlinePaymentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsReturnFromExternalPaymentProviderAfterOnlinePayment = function (params) {
    return { evid: 519, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsOneAppIapSendMessageClickParams
* @property {string} bookingsPlatform - null
* @property {string} resourceId - staff / resource
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {string} couponId - if exists
* @property {string} currency - currency
* @property {number} depositValue - if exists, multiplied by 100000
* @property {string} loaction - chosen location type
* @property {GUID} biToken - null
* @property {string} onlineConferenceProvider - zoom, custom
* @property {string} paymentMethod - {offline,online,both, paid_plan_limited, paid_plan_unlimited}
* @property {number} price - service price multiplied by 100000
* @property {string} pricingPlanId - pricing plan id
* @property {string} scheduleId - service schedule id
* @property {string} serviceId - service id
* @property {string} sessionId - session id if class
* @property {DateTime} startTime - session / service start time
* @property {string} serviceType - {class\ind\course}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > Member Mobile App > IAP Send Message > Click. Evid: 607.
 * Event description: Click on "Send Message" action sheet when service isn't available to purchase using the app.

 * bookingsPlatform - Type: string.
 *
 * resourceId - Type: string. Desc: staff / resource
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * couponId - Type: string. Desc: if exists
 *
 * currency - Type: string. Desc: currency
 *
 * depositValue - Type: numeric. Desc: if exists, multiplied by 100000
 *
 * loaction - Type: string. Desc: chosen location type
 *
 * biToken - Type: guid.
 *
 * onlineConferenceProvider - Type: string. Desc: zoom, custom
 *
 * paymentMethod - Type: string. Desc: {offline,online,both, paid_plan_limited, paid_plan_unlimited}
 *
 * price - Type: numeric. Desc: service price multiplied by 100000
 *
 * pricingPlanId - Type: string. Desc: pricing plan id
 *
 * scheduleId - Type: string. Desc: service schedule id
 *
 * serviceId - Type: string. Desc: service id
 *
 * sessionId - Type: string. Desc: session id if class
 *
 * startTime - Type: datetime. Desc: session / service start time
 *
 * serviceType - Type: string. Desc: {class\ind\course}
 *
 * visitor_id - Type: guid.
 * @param {bookingsOneAppIapSendMessageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsOneAppIapSendMessageClick = function (params) {
    return { evid: 607, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsSendPageIdParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - null
* @property {string} pid - page_id
* @property {GUID} visitor_id - null
**/
/**
 * Name: NO DATA - bookings > send page id. Evid: 514.
 * Event description: send page id. Since 30 of May we're not sending this.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid.
 *
 * pid - Type: string. Desc: page_id
 *
 * visitor_id - Type: guid.
 * @param {bookingsSendPageIdParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsSendPageId = function (params) {
    return { evid: 514, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsLoginUserAccountAppointmentsRescheduleSuccessParams
* @property {GUID} appointmentId - appointment rescheduled
* @property {string} bookingId - book rescheduled
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {string} businessProperties - -
* @property {GUID} contactId - null
* @property {string} defaultDateAtFirstLoad - -
* @property {string} selectedFilters - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPremium - -
* @property {boolean} isPreview - null
* @property {string} userMessage - -
* @property {GUID} biToken - null
* @property {string} pageName - -
* @property {string} referralInfo - -
* @property {string} selectedDate - -
* @property {string} serviceid - service rescheduled
* @property {string} serviceId - -
* @property {string} serviceProperties - -
* @property {string} selectedTimezone - -
* @property {string} serviceType - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Member Area > My Bookings > Reschedule Success. Evid: 551.
 * Event description: on the user account (myaccount) page > appointments tab - after click on reschedule (appointment http://prntscr.com/dq9z2z) the visitor choose another date & time and clicks on next --> reschedule success.

 * appointmentId - Type: guid. Desc: appointment rescheduled
 *
 * bookingId - Type: string. Desc: book rescheduled
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * businessProperties - Type: string. Desc: -
 *
 * contactId - Type: guid.
 *
 * defaultDateAtFirstLoad - Type: string. Desc: -
 *
 * selectedFilters - Type: string. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPremium - Type: bool. Desc: -
 *
 * isPreview - Type: bool.
 *
 * userMessage - Type: string. Desc: -
 *
 * biToken - Type: guid.
 *
 * pageName - Type: string. Desc: -
 *
 * referralInfo - Type: string. Desc: -
 *
 * selectedDate - Type: string. Desc: -
 *
 * serviceid - Type: string. Desc: service rescheduled
 *
 * serviceId - Type: string. Desc: -
 *
 * serviceProperties - Type: string. Desc: -
 *
 * selectedTimezone - Type: string. Desc: -
 *
 * serviceType - Type: string. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsLoginUserAccountAppointmentsRescheduleSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsLoginUserAccountAppointmentsRescheduleSuccess = function (params) {
    return { evid: 551, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsLoginUserAccountAppointmentsCancelClickParams
* @property {GUID} appointmentId - appointment rescheduled
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {boolean} confirmation - T= confirmation for delete F= first click
* @property {GUID} contactId - null
* @property {boolean} is_owner - is_owner
* @property {boolean} isPendingApproval - T/F for pending approval service
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} referralInfo - {upcoming, one_app_main_tab, one_app_upcoming_my_bookings, one_app_group_session_select}
* @property {string} serviceid - service rescheduled
* @property {string} session_id - null
* @property {string} type - Service type {appointment, class, course}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Member Area > My bookings > Cancel Click. Evid: 547.
 * Event description: on the member area > appointments tab - click on cancel session. for the first click (http://prntscr.com/dq9zox) send confirmation=F, for the second (http://prntscr.com/dqa01c) send confirmation=T.

 * appointmentId - Type: guid. Desc: appointment rescheduled
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * confirmation - Type: bool. Desc: T= confirmation for delete F= first click
 *
 * contactId - Type: guid.
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPendingApproval - Type: bool. Desc: T/F for pending approval service
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * referralInfo - Type: string. Desc: {upcoming, one_app_main_tab, one_app_upcoming_my_bookings, one_app_group_session_select}
 *
 * serviceid - Type: string. Desc: service rescheduled
 *
 * session_id - Type: string.
 *
 * type - Type: string. Desc: Service type {appointment, class, course}
 *
 * visitor_id - Type: guid.
 * @param {bookingsLoginUserAccountAppointmentsCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsLoginUserAccountAppointmentsCancelClick = function (params) {
    return { evid: 547, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsCalendarTimePickerLoadParams
* @property {string} bookingId - If reschedule then value is not null
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - business_id
* @property {string} businessProperties - business properties
* @property {GUID} contactId - contact_id
* @property {string} defaultDateAtFirstLoad - -
* @property {string} selectedFilters - filters
* @property {boolean} isPremium - T/F
* @property {string} layout - weekly, daily_month (monthly)
* @property {string} userMessage - -
* @property {GUID} biToken - msid
* @property {string} pageName - -
* @property {string} referralInfo - service_list_widget' | 'service_details_widget' | 'members_area_reschedule' | 'members_area_book_again'
* @property {string} selectedDate - -
* @property {string} selectedRange - selected range shown
* @property {string} serviceId - service_id
* @property {string} serviceProperties - service properties
* @property {string} timeSlotsAvailability - -
* @property {string} selectedTimezone - timezone
* @property {string} triggeredBy - -
* @property {string} serviceType - service type
* @property {string} visibleRange - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > calendar > time picker load. Evid: 595.
 * Event description: calendar date picker load.

 * bookingId - Type: string. Desc: If reschedule then value is not null
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: business_id
 *
 * businessProperties - Type: string. Desc: business properties
 *
 * contactId - Type: guid. Desc: contact_id
 *
 * defaultDateAtFirstLoad - Type: string. Desc: -
 *
 * selectedFilters - Type: string. Desc: filters
 *
 * isPremium - Type: bool. Desc: T/F
 *
 * layout - Type: string. Desc: weekly, daily_month (monthly)
 *
 * userMessage - Type: string. Desc: -
 *
 * biToken - Type: guid. Desc: msid
 *
 * pageName - Type: string. Desc: -
 *
 * referralInfo - Type: string. Desc: service_list_widget' | 'service_details_widget' | 'members_area_reschedule' | 'members_area_book_again'
 *
 * selectedDate - Type: string. Desc: -
 *
 * selectedRange - Type: string. Desc: selected range shown
 *
 * serviceId - Type: string. Desc: service_id
 *
 * serviceProperties - Type: string. Desc: service properties
 *
 * timeSlotsAvailability - Type: string. Desc: -
 *
 * selectedTimezone - Type: string. Desc: timezone
 *
 * triggeredBy - Type: string. Desc: -
 *
 * serviceType - Type: string. Desc: service type
 *
 * visibleRange - Type: string. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsCalendarTimePickerLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsCalendarTimePickerLoad = function (params) {
    return { evid: 595, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsCalendarPageLoadedParams
* @property {string} bookingId - null
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {string} businessProperties - business prop for ooi calendar only
* @property {GUID} contactId - null
* @property {string} defaultDateAtFirstLoad - for ooi calendar only
* @property {string} errorMessage - empty state etc.
* @property {string} selectedFilters - null
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {string} layout - weekly, daily_month
* @property {GUID} biToken - null
* @property {string} pageName - page name
* @property {string} referralInfo - {NULL= app settings, widget}
* @property {string} selectedDate - selected date for ooi calendar only
* @property {string} selectedRange - selected range shown
* @property {string} service_id - -
* @property {string} serviceId - service_id value
* @property {string} serviceProperties - null
* @property {string} type - {class\ind}
* @property {string} serviceType - service type for ooi calendar only
* @property {string} visibleRange - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Calendar > Page Loaded. Evid: 541.
 * Event description: calendar page loaded - sent only from the widget as a referal.

 * bookingId - Type: string.
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * businessProperties - Type: string. Desc: business prop for ooi calendar only
 *
 * contactId - Type: guid.
 *
 * defaultDateAtFirstLoad - Type: string. Desc: for ooi calendar only
 *
 * errorMessage - Type: string. Desc: empty state etc.
 *
 * selectedFilters - Type: string.
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * layout - Type: string. Desc: weekly, daily_month
 *
 * biToken - Type: guid.
 *
 * pageName - Type: string. Desc: page name
 *
 * referralInfo - Type: string. Desc: {NULL= app settings, widget}
 *
 * selectedDate - Type: string. Desc: selected date for ooi calendar only
 *
 * selectedRange - Type: string. Desc: selected range shown
 *
 * service_id - Type: string. Desc: -
 *
 * serviceId - Type: string. Desc: service_id value
 *
 * serviceProperties - Type: string.
 *
 * type - Type: string. Desc: {class\ind}
 *
 * serviceType - Type: string. Desc: service type for ooi calendar only
 *
 * visibleRange - Type: string. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsCalendarPageLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsCalendarPageLoaded = function (params) {
    return { evid: 541, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsUpgradeReferralClickUserAsUouParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - -
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - -
* @property {boolean} isPreview - 1 if this is preview mode, 0 if live site
* @property {GUID} biToken - -
* @property {string} premiumStatus - {free,non_bookings_premium}
* @property {string} referral_info - {Payments, Booking}
* @property {string} type - Service type {appointment, class, course}
* @property {GUID} visitor_id - -
**/
/**
 * Name: Bookings > UoU > Upgrade Referral Click (User as UoU). Evid: 559.
 * Event description: http://prntscr.com/g0jwsx.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: -
 *
 * isPreview - Type: bool. Desc: 1 if this is preview mode, 0 if live site
 *
 * biToken - Type: guid. Desc: -
 *
 * premiumStatus - Type: string. Desc: {free,non_bookings_premium}
 *
 * referral_info - Type: string. Desc: {Payments, Booking}
 *
 * type - Type: string. Desc: Service type {appointment, class, course}
 *
 * visitor_id - Type: guid. Desc: -
 * @param {bookingsUpgradeReferralClickUserAsUouParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsUpgradeReferralClickUserAsUou = function (params) {
    return { evid: 559, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsTimeTableWidgetLoadParams
* @property {string} additionalInfo - date presented
* @property {string} bookingsPlatform - -
* @property {GUID} businessId - -
* @property {GUID} contactId - -
* @property {boolean} isEmptyState - true = empty state
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - -
* @property {GUID} visitor_id - -
* @property {string} widget_name - {daily_time_table, weekly_time_table}
**/
/**
 * Name: Bookings > UoU > calendar > time table widget >  load. Evid: 580.
 * Event description: calendar page loaded - sent only from the widget as a referal.

 * additionalInfo - Type: string. Desc: date presented
 *
 * bookingsPlatform - Type: string. Desc: -
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid. Desc: -
 *
 * isEmptyState - Type: bool. Desc: true = empty state
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid. Desc: -
 *
 * visitor_id - Type: guid. Desc: -
 *
 * widget_name - Type: string. Desc: {daily_time_table, weekly_time_table}
 * @param {bookingsTimeTableWidgetLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsTimeTableWidgetLoad = function (params) {
    return { evid: 580, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsTimeZoneDiscrepancyParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - -
* @property {string} contact_id - optional
* @property {GUID} contactId - null
* @property {string} local_date_time - -
* @property {GUID} biToken - null
* @property {string} source - Server/BO
* @property {string} timezone - timezone on which there was a discrepancy
* @property {number} timestamp - epoch time
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > Calendar > TimeZone Discrepancy. Evid: 1014.
 * Event description: This event is reported when there is a discrepancy between the business timezone and the user/uou timezone when calendar loads or when uou tries to book.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: -
 *
 * contact_id - Type: string. Desc: optional
 *
 * contactId - Type: guid.
 *
 * local_date_time - Type: string. Desc: -
 *
 * biToken - Type: guid.
 *
 * source - Type: string. Desc: Server/BO
 *
 * timezone - Type: string. Desc: timezone on which there was a discrepancy
 *
 * timestamp - Type: numeric. Desc: epoch time
 *
 * visitor_id - Type: guid.
 * @param {bookingsTimeZoneDiscrepancyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsTimeZoneDiscrepancy = function (params) {
    return { evid: 1014, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsPaymentsPopupForUserAsUouOpenedParams
* @property {string} additionalInfo - description of the modal/popup flow {waitlist_flow_download_oa}
* @property {string} bookingId - booking_id
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - -
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - is_over_editor
* @property {boolean} isPreview - 1 if this is preview mode, 0 if live site
* @property {GUID} biToken - -
* @property {string} premiumStatus - {free,non_bookings_premium}
* @property {string} referral_info - {Payments/Booking/Waitlist/Booking_Cancellation/Double_Booking_Reschedule/Double_Booking_Payment_Page/Double_Booking_Form_Page/Double_Booking_Payment_Page_Book}
* @property {GUID} serviceId - --
* @property {string} sessionId - null
* @property {string} type - Service type {appointment, class, course}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU >  Popup Opened For UoU. Evid: 558.
 * Event description: Till November-2019: Bookings > popup for user as UoU opened.
Similar to evid 157 on users schema  - popup opens for owner only on preview mode or live. From November-2019: Bookings > popup opened for UoU. For any popup opens to UoU..

 * additionalInfo - Type: string. Desc: description of the modal/popup flow {waitlist_flow_download_oa}
 *
 * bookingId - Type: string. Desc: booking_id
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: is_over_editor
 *
 * isPreview - Type: bool. Desc: 1 if this is preview mode, 0 if live site
 *
 * biToken - Type: guid. Desc: -
 *
 * premiumStatus - Type: string. Desc: {free,non_bookings_premium}
 *
 * referral_info - Type: string. Desc: {Payments/Booking/Waitlist/Booking_Cancellation/Double_Booking_Reschedule/Double_Booking_Payment_Page/Double_Booking_Form_Page/Double_Booking_Payment_Page_Book}
 *
 * serviceId - Type: guid. Desc: --
 *
 * sessionId - Type: string.
 *
 * type - Type: string. Desc: Service type {appointment, class, course}
 *
 * visitor_id - Type: guid.
 * @param {bookingsPaymentsPopupForUserAsUouOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsPaymentsPopupForUserAsUouOpened = function (params) {
    return { evid: 558, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsMobileAppsClickOnBuyMembershipParams
* @property {string} bookingsPlatform - --
* @property {GUID} businessId - business_id
* @property {GUID} contactId - null
* @property {string} eligiblePricingPlanId - Id of the chosen pricing plan
* @property {GUID} biToken - msid
* @property {string} selectedMethod - selected payment method {pay in person, pay online, purchase pricing plan, use pricing plan + pp id}
* @property {string} serviceId - serviceId
* @property {string} sessionId - --
* @property {string} type - service type - {individual, groups}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > Member Mobile App > Service Page Buy Membership > Click. Evid: 626.
 * Event description: Click on "Buy membership" (from the service page where a plan is connected).

 * bookingsPlatform - Type: string. Desc: --
 *
 * businessId - Type: guid. Desc: business_id
 *
 * contactId - Type: guid.
 *
 * eligiblePricingPlanId - Type: string. Desc: Id of the chosen pricing plan
 *
 * biToken - Type: guid. Desc: msid
 *
 * selectedMethod - Type: string. Desc: selected payment method {pay in person, pay online, purchase pricing plan, use pricing plan + pp id}
 *
 * serviceId - Type: string. Desc: serviceId
 *
 * sessionId - Type: string. Desc: --
 *
 * type - Type: string. Desc: service type - {individual, groups}
 *
 * visitor_id - Type: guid.
 * @param {bookingsMobileAppsClickOnBuyMembershipParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsMobileAppsClickOnBuyMembership = function (params) {
    return { evid: 626, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsCalendarChooseStaffMemberPopupOpenedParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} resourceList - "location_guid" or "location_text":"[staff list]"
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Calendar > Choose Staff Member Popup Opened. Evid: 531.
 * Event description: sent when the tooltip of choose member is opened in the calendar (only services that have more than one member defined).

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * resourceList - Type: string. Desc: "location_guid" or "location_text":"[staff list]"
 *
 * visitor_id - Type: guid.
 * @param {bookingsCalendarChooseStaffMemberPopupOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsCalendarChooseStaffMemberPopupOpened = function (params) {
    return { evid: 531, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsOneAppMeTabBookAgainTapParams
* @property {string} bookingId - new booking_id
* @property {string} bookingsPlatform - new_bookings_server
* @property {GUID} businessId - business_id
* @property {GUID} contactId - -
* @property {boolean} isPendingApproval - TRUE for pending approval services
* @property {GUID} biToken - msid
* @property {string} serviceId - service_id
* @property {string} type - service type {class\ind\course}
* @property {GUID} visitor_id - visitor_id
* @property {boolean} waitlistEnabled - TRUE if waitlist enabled
**/
/**
 * Name: Bookings > Member Mobile App > OneApp --> Me Tab --> book again.tap. Evid: 585.
 * Event description: member taps on an booking  in me tab, history section.

 * bookingId - Type: string. Desc: new booking_id
 *
 * bookingsPlatform - Type: string. Desc: new_bookings_server
 *
 * businessId - Type: guid. Desc: business_id
 *
 * contactId - Type: guid. Desc: -
 *
 * isPendingApproval - Type: bool. Desc: TRUE for pending approval services
 *
 * biToken - Type: guid. Desc: msid
 *
 * serviceId - Type: string. Desc: service_id
 *
 * type - Type: string. Desc: service type {class\ind\course}
 *
 * visitor_id - Type: guid. Desc: visitor_id
 *
 * waitlistEnabled - Type: bool. Desc: TRUE if waitlist enabled
 * @param {bookingsOneAppMeTabBookAgainTapParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsOneAppMeTabBookAgainTap = function (params) {
    return { evid: 585, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsPaymentsSentToPaymentProviderParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - null
* @property {string} paymentProvider - NULL=paypal, stripe
* @property {string} type - {class\ind}
* @property {GUID} visitor_id - null
**/
/**
 * Name: NO DATA - bookings > Payments>sent to payment_provider. Evid: 528.
 * Event description: paypal window is opened when clicked on 'pay now' - payment of the service was defined online.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid.
 *
 * paymentProvider - Type: string. Desc: NULL=paypal, stripe
 *
 * type - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid.
 * @param {bookingsPaymentsSentToPaymentProviderParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsPaymentsSentToPaymentProvider = function (params) {
    return { evid: 528, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsMobileAppsLoadPaymentMethodScreenParams
* @property {string} bookingsPlatform - --
* @property {GUID} businessId - business_id
* @property {GUID} contactId - -
* @property {GUID} biToken - msid
* @property {string} offeredPaymentTypes - all of the options offered to the UoU. {pay in person, pay online, purchase pricing plan, use pricing plan + pp id, eligible PP Ids}
* @property {string} serviceId - serviceId
* @property {string} sessionId - --
* @property {string} serviceType - service type - {class,course,appointment}
* @property {GUID} visitorId - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > Member Mobile App > Payments Payment Method Screen > Load. Evid: 657.
 * Event description: when the screen with all the pricing method options is loaded in spaces.

 * bookingsPlatform - Type: string. Desc: --
 *
 * businessId - Type: guid. Desc: business_id
 *
 * contactId - Type: guid. Desc: -
 *
 * biToken - Type: guid. Desc: msid
 *
 * offeredPaymentTypes - Type: string. Desc: all of the options offered to the UoU. {pay in person, pay online, purchase pricing plan, use pricing plan + pp id, eligible PP Ids}
 *
 * serviceId - Type: string. Desc: serviceId
 *
 * sessionId - Type: string. Desc: --
 *
 * serviceType - Type: string. Desc: service type - {class,course,appointment}
 *
 * visitorId - Type: guid. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsMobileAppsLoadPaymentMethodScreenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsMobileAppsLoadPaymentMethodScreen = function (params) {
    return { evid: 657, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsContactInfoSaveSuccessParams
* @property {string} formId - -
* @property {string} bookingId - booking_id = order_id in evid 16:1010
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {string} businessProperties - -
* @property {string} catId - null
* @property {GUID} contactId - null
* @property {string} currency - null
* @property {number} depositAmount - null
* @property {string} selectedFilters - -
* @property {boolean} isCouponCode - T if used coupon
* @property {boolean} is_over_editor - null
* @property {boolean} is_owner - null
* @property {boolean} isPremium - -
* @property {boolean} isPreview - null
* @property {boolean} isUoUloggedIn - T if logged in
* @property {string} language - site language
* @property {boolean} message_empty - null
* @property {GUID} biToken - null
* @property {number} numParticipants - null
* @property {number} numberOfRequiredFields - numbers of fields the UoU needs to fill
* @property {string} pageName - -
* @property {string} paymentDetails - {Existing pricing plan/New Pricing Plan/ single}
* @property {string} paymentType - online / offline
* @property {string} platform - null
* @property {number} price - null
* @property {string} price_selection - null
* @property {string} properties - -
* @property {string} referralInfo - -
* @property {string} selectedLocation - location of service. Relevant to Booking Form
* @property {string} selectedRange - selected range shown
* @property {string} serviceId - null
* @property {string} servicePaymentOptions - what are this service payment options available
* @property {string} serviceProperties - -
* @property {string} sessionId - --
* @property {boolean} smsCapability - T if sms reminder option is available
* @property {boolean} smsNotificationRequest - T/F
* @property {GUID} staffId - staff_id
* @property {string} target - target page after next click
* @property {string} timeslot - session start time
* @property {string} selectedSlot - -
* @property {string} selectedTimezone - -
* @property {string} type - null
* @property {string} serviceType - -
* @property {string} uouPaymentOptions - What are the payment options the uou owns
* @property {string} visibleRange - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Book Flow > Calendar/Form > Next Button Click Success. Evid: 517.
 * Event description: contact info save success / calendar next success.

 * formId - Type: string. Desc: -
 *
 * bookingId - Type: string. Desc: booking_id = order_id in evid 16:1010
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * businessProperties - Type: string. Desc: -
 *
 * catId - Type: string.
 *
 * contactId - Type: guid.
 *
 * currency - Type: string.
 *
 * depositAmount - Type: numeric.
 *
 * selectedFilters - Type: string. Desc: -
 *
 * isCouponCode - Type: bool. Desc: T if used coupon
 *
 * is_over_editor - Type: bool.
 *
 * is_owner - Type: bool.
 *
 * isPremium - Type: bool. Desc: -
 *
 * isPreview - Type: bool.
 *
 * isUoUloggedIn - Type: bool. Desc: T if logged in
 *
 * language - Type: string. Desc: site language
 *
 * message_empty - Type: bool.
 *
 * biToken - Type: guid.
 *
 * numParticipants - Type: numeric.
 *
 * numberOfRequiredFields - Type: numeric. Desc: numbers of fields the UoU needs to fill
 *
 * pageName - Type: string. Desc: -
 *
 * paymentDetails - Type: string. Desc: {Existing pricing plan/New Pricing Plan/ single}
 *
 * paymentType - Type: string. Desc: online / offline
 *
 * platform - Type: string.
 *
 * price - Type: numeric.
 *
 * price_selection - Type: string.
 *
 * properties - Type: string. Desc: -
 *
 * referralInfo - Type: string. Desc: -
 *
 * selectedLocation - Type: string. Desc: location of service. Relevant to Booking Form
 *
 * selectedRange - Type: string. Desc: selected range shown
 *
 * serviceId - Type: string.
 *
 * servicePaymentOptions - Type: string. Desc: what are this service payment options available
 *
 * serviceProperties - Type: string. Desc: -
 *
 * sessionId - Type: string. Desc: --
 *
 * smsCapability - Type: bool. Desc: T if sms reminder option is available
 *
 * smsNotificationRequest - Type: bool. Desc: T/F
 *
 * staffId - Type: guid. Desc: staff_id
 *
 * target - Type: string. Desc: target page after next click
 *
 * timeslot - Type: string. Desc: session start time
 *
 * selectedSlot - Type: string. Desc: -
 *
 * selectedTimezone - Type: string. Desc: -
 *
 * type - Type: string.
 *
 * serviceType - Type: string. Desc: -
 *
 * uouPaymentOptions - Type: string. Desc: What are the payment options the uou owns
 *
 * visibleRange - Type: string. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsContactInfoSaveSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsContactInfoSaveSuccess = function (params) {
    return { evid: 517, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsWidgetPageLoadedParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - null
* @property {number} numOfServices - 0 if no services in the widget
* @property {string} origin - {staff_widget}
* @property {string} serviceId - -
* @property {GUID} visitor_id - null
* @property {string} widget_name - widget version
**/
/**
 * Name: Bookings > UoU > Book Flow > Widget Loaded On Page. Evid: 540.
 * Event description: widget page loaded - sent once for each widget (being sent for both UoU action and user action - when drag widget to site).

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid.
 *
 * numOfServices - Type: numeric. Desc: 0 if no services in the widget
 *
 * origin - Type: string. Desc: {staff_widget}
 *
 * serviceId - Type: string. Desc: -
 *
 * visitor_id - Type: guid.
 *
 * widget_name - Type: string. Desc: widget version
 * @param {bookingsWidgetPageLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsWidgetPageLoaded = function (params) {
    return { evid: 540, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsServicesPageViewParams
* @property {boolean} accept_online_bookings - FALSE only if this a "no book flow"
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - -
* @property {GUID} contactId - null
* @property {string} containers - null
* @property {boolean} emptyState - T if empty state, F if not
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {string} message_to_user - {fully booked, not yet opened to bookings, not accepting bookings, service not available}
* @property {GUID} biToken - msid
* @property {string} platform - platform of user. example: "mobile".
* @property {string} referralInfo - visitor origin to the SP. {'service title', 'learn more', 'service card deep link'}
* @property {string} sections - null
* @property {string} serviceId - null
* @property {GUID} siteMemberId - member_id
* @property {string} type - group\private\course
* @property {GUID} visitor_id - -
**/
/**
 * Name: Bookings > UoU >  Book Flow > Service Page View. Evid: 560.
 * Event description: services page opened.

 * accept_online_bookings - Type: bool. Desc: FALSE only if this a "no book flow"
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid.
 *
 * containers - Type: string.
 *
 * emptyState - Type: bool. Desc: T if empty state, F if not
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * message_to_user - Type: string. Desc: {fully booked, not yet opened to bookings, not accepting bookings, service not available}
 *
 * biToken - Type: guid. Desc: msid
 *
 * platform - Type: string. Desc: platform of user. example: "mobile".
 *
 * referralInfo - Type: string. Desc: visitor origin to the SP. {'service title', 'learn more', 'service card deep link'}
 *
 * sections - Type: string.
 *
 * serviceId - Type: string.
 *
 * siteMemberId - Type: guid. Desc: member_id
 *
 * type - Type: string. Desc: group\private\course
 *
 * visitor_id - Type: guid. Desc: -
 * @param {bookingsServicesPageViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsServicesPageView = function (params) {
    return { evid: 560, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsLoginUserAccountTabNavigatorParams
* @property {string} bookingsPlatform - -
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} isEmptyState - is appointments list empty
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} selection - {history/ upcoming}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Member Area > Tab Navigator Click. Evid: 548.
 * Event description: click on the tab navigator on the user account page - http://prntscr.com/dqa0c9.

 * bookingsPlatform - Type: string. Desc: -
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * isEmptyState - Type: bool. Desc: is appointments list empty
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * selection - Type: string. Desc: {history/ upcoming}
 *
 * visitor_id - Type: guid.
 * @param {bookingsLoginUserAccountTabNavigatorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsLoginUserAccountTabNavigator = function (params) {
    return { evid: 548, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsLoginFinishedRefreshAfterLoginParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - -
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - -
* @property {boolean} isPreview - T/F
* @property {GUID} biToken - msid
* @property {GUID} visitor_id - logged in visitor
* @property {GUID} visitorIdAnon - the visitor_id when the visitor is anonymous- not logged in
**/
/**
 * Name: Bookings > UoU > Login Finished Refresh After Login. Evid: 557.
 * Event description: bookings >finished refresh after login.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: -
 *
 * isPreview - Type: bool. Desc: T/F
 *
 * biToken - Type: guid. Desc: msid
 *
 * visitor_id - Type: guid. Desc: logged in visitor
 *
 * visitorIdAnon - Type: guid. Desc: the visitor_id when the visitor is anonymous- not logged in
 * @param {bookingsLoginFinishedRefreshAfterLoginParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsLoginFinishedRefreshAfterLogin = function (params) {
    return { evid: 557, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsCalendarErrorMessagesParams
* @property {string} bookingId - If not null then reschedule
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {string} businessProperties - business properties
* @property {GUID} contactId - null
* @property {string} defaultDateAtFirstLoad - -
* @property {string} errorMessage - Fetching date availably failed\Fetching slots availably failed\Rescheduling failed\No next available date\Next available date server error\service not found\Fetch service data error
* @property {string} selectedFilters - filters
* @property {boolean} isPremium - T/F
* @property {GUID} biToken - null
* @property {string} pageName - -
* @property {string} properties - -
* @property {string} referralInfo - referral
* @property {string} selectedDate - default date
* @property {string} serviceId - service_id
* @property {string} serviceProperties - service properties
* @property {string} selectedTimezone - timezone
* @property {string} serviceType - {class\ind}
* @property {string} visibleRange - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Calendar Error Message > Show. Evid: 603.
 * Event description: error message presented to uou
Example: https://zpl.io/agR5R6A.

 * bookingId - Type: string. Desc: If not null then reschedule
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * businessProperties - Type: string. Desc: business properties
 *
 * contactId - Type: guid.
 *
 * defaultDateAtFirstLoad - Type: string. Desc: -
 *
 * errorMessage - Type: string. Desc: Fetching date availably failed\Fetching slots availably failed\Rescheduling failed\No next available date\Next available date server error\service not found\Fetch service data error
 *
 * selectedFilters - Type: string. Desc: filters
 *
 * isPremium - Type: bool. Desc: T/F
 *
 * biToken - Type: guid.
 *
 * pageName - Type: string. Desc: -
 *
 * properties - Type: string. Desc: -
 *
 * referralInfo - Type: string. Desc: referral
 *
 * selectedDate - Type: string. Desc: default date
 *
 * serviceId - Type: string. Desc: service_id
 *
 * serviceProperties - Type: string. Desc: service properties
 *
 * selectedTimezone - Type: string. Desc: timezone
 *
 * serviceType - Type: string. Desc: {class\ind}
 *
 * visibleRange - Type: string. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsCalendarErrorMessagesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsCalendarErrorMessages = function (params) {
    return { evid: 603, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsLoginClickParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} pageName - {service_list,calendar,personal_info...}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Login Click. Evid: 542.
 * Event description: click on login.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * pageName - Type: string. Desc: {service_list,calendar,personal_info...}
 *
 * visitor_id - Type: guid.
 * @param {bookingsLoginClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsLoginClick = function (params) {
    return { evid: 542, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsPricingPlansViewParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - business_id
* @property {GUID} contactId - contact_id
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - msid
* @property {number} number_of_plans - number of defined plans
* @property {string} pid - page_id
* @property {GUID} site_member_id - site_member_id - logged user
* @property {GUID} visitor_id - visitor_id
**/
/**
 * Name: Bookings > UoU > Book Flow > Pricing Plans - View. Evid: 567.
 * Event description: pricing plans page opened.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: business_id
 *
 * contactId - Type: guid. Desc: contact_id
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid. Desc: msid
 *
 * number_of_plans - Type: numeric. Desc: number of defined plans
 *
 * pid - Type: string. Desc: page_id
 *
 * site_member_id - Type: guid. Desc: site_member_id - logged user
 *
 * visitor_id - Type: guid. Desc: visitor_id
 * @param {bookingsPricingPlansViewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsPricingPlansView = function (params) {
    return { evid: 567, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsOpenBookingsAppFromTheWidgetParams
* @property {boolean} accept_online_bookings - FALSE only if this a "no book flow"
* @property {string} booking_intent - {book it / more info = image and description}
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - -
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - is_preview
* @property {GUID} biToken - msid
* @property {string} referralInfo - {widget/wixCode}
* @property {GUID} service_id - service_id
* @property {string} type - group\private
* @property {GUID} visitor_id - -
**/
/**
 * Name: Bookings > UoU > Open Bookings App From The Widget. Evid: 577.
 * Event description: Bookings --> open Bookings app from the widget.

 * accept_online_bookings - Type: bool. Desc: FALSE only if this a "no book flow"
 *
 * booking_intent - Type: string. Desc: {book it / more info = image and description}
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool. Desc: is_preview
 *
 * biToken - Type: guid. Desc: msid
 *
 * referralInfo - Type: string. Desc: {widget/wixCode}
 *
 * service_id - Type: guid. Desc: service_id
 *
 * type - Type: string. Desc: group\private
 *
 * visitor_id - Type: guid. Desc: -
 * @param {bookingsOpenBookingsAppFromTheWidgetParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsOpenBookingsAppFromTheWidget = function (params) {
    return { evid: 577, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsSystemMessageCloseParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} referal_info - {date&time, contact_info}
* @property {string} type - {class\ind}
* @property {GUID} visitor_id - null
**/
/**
 * Name: NO DATA - bookings > system message close. Evid: 511.
 * Event description: Cancelled.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * referal_info - Type: string. Desc: {date&time, contact_info}
 *
 * type - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid.
 * @param {bookingsSystemMessageCloseParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsSystemMessageClose = function (params) {
    return { evid: 511, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsOneAppMeTabUpcomingTapParams
* @property {string} bookingId - booking_id
* @property {string} bookingsPlatform - new_bookings_server
* @property {GUID} businessId - business_id
* @property {GUID} contactId - -
* @property {boolean} isPendingApproval - TRUE for pending approval services
* @property {GUID} biToken - null
* @property {string} serviceId - service_id
* @property {string} type - service type {class\ind\course}
* @property {GUID} visitor_id - null
* @property {boolean} waitlistEnabled - TRUE if waitlist enabled
**/
/**
 * Name: Bookings > Member Mobile App > OneApp --> Me Tab --> upcoming.tap. Evid: 584.
 * Event description: member taps on an booking  in me tab, upcoming section.

 * bookingId - Type: string. Desc: booking_id
 *
 * bookingsPlatform - Type: string. Desc: new_bookings_server
 *
 * businessId - Type: guid. Desc: business_id
 *
 * contactId - Type: guid. Desc: -
 *
 * isPendingApproval - Type: bool. Desc: TRUE for pending approval services
 *
 * biToken - Type: guid.
 *
 * serviceId - Type: string. Desc: service_id
 *
 * type - Type: string. Desc: service type {class\ind\course}
 *
 * visitor_id - Type: guid.
 *
 * waitlistEnabled - Type: bool. Desc: TRUE if waitlist enabled
 * @param {bookingsOneAppMeTabUpcomingTapParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsOneAppMeTabUpcomingTap = function (params) {
    return { evid: 584, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsOneAppDeletePromoCodeParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - business_id
* @property {GUID} contactId - null
* @property {GUID} couponId - coupon_id
* @property {GUID} biToken - msid
* @property {string} type - service type {class\ind\course}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > Member Mobile App > OneApp --> delete promo code. Evid: 576.
 * Event description: Delete promo code after applying it - after clicking "save" with removing the code.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: business_id
 *
 * contactId - Type: guid.
 *
 * couponId - Type: guid. Desc: coupon_id
 *
 * biToken - Type: guid. Desc: msid
 *
 * type - Type: string. Desc: service type {class\ind\course}
 *
 * visitor_id - Type: guid.
 * @param {bookingsOneAppDeletePromoCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsOneAppDeletePromoCode = function (params) {
    return { evid: 576, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsAnotherParticipantActionsPhase2Params
* @property {string} action - {remove, edit}
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - null
* @property {string} serviceId - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: NO DATA - bookings > another participant actions - phase 2. Evid: 536.
 * Event description: click on edit\remove of another participants
http://prntscr.com/bjzijo.

 * action - Type: string. Desc: {remove, edit}
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid.
 *
 * serviceId - Type: string. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsAnotherParticipantActionsPhase2Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsAnotherParticipantActionsPhase2 = function (params) {
    return { evid: 536, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsOneAppClickOnEnterPromoCodeEditCodeParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - business_id
* @property {GUID} contactId - null
* @property {GUID} couponId - coupon_id - when edited
* @property {GUID} biToken - msid
* @property {string} screenName - booking_summary / other options?
* @property {string} type - {class\ind\course}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > Member Mobile App > OneApp --> click on "enter promo code"/Edit code. Evid: 574.
 * Event description: Click on enter promo code from Bookings summary page.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: business_id
 *
 * contactId - Type: guid.
 *
 * couponId - Type: guid. Desc: coupon_id - when edited
 *
 * biToken - Type: guid. Desc: msid
 *
 * screenName - Type: string. Desc: booking_summary / other options?
 *
 * type - Type: string. Desc: {class\ind\course}
 *
 * visitor_id - Type: guid.
 * @param {bookingsOneAppClickOnEnterPromoCodeEditCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsOneAppClickOnEnterPromoCodeEditCode = function (params) {
    return { evid: 574, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsTodayCalendarParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} type - {class\ind}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Calendar > Today Calendar Click. Evid: 505.
 * Event description: today calendar.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * type - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid.
 * @param {bookingsTodayCalendarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsTodayCalendar = function (params) {
    return { evid: 505, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsMemberAreaListUploadParams
* @property {number} amountSessions - the amount of sessions that in the tab
* @property {string} bookingsPlatform -
* @property {GUID} businessId - -
* @property {GUID} contactId - -
* @property {boolean} isEmptyState - is appointments list empty
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - -
* @property {boolean} reschedule - {F = all reschedule disables or empty state; T = at least one reschedule}
* @property {string} tabName - {upcoming, history}
* @property {GUID} visitor_id - -
**/
/**
 * Name: Bookings > UoU > Members Area > My Bookings > List Loaded. Evid: 562.
 * Event description: services list loaded (history/upcoming)
http://prntscr.com/gsp5qm, OneApp: https://www.screencast.com/t/PKX1IdXTOm. Sends from mobile as well!!.

 * amountSessions - Type: numeric. Desc: the amount of sessions that in the tab
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid. Desc: -
 *
 * isEmptyState - Type: bool. Desc: is appointments list empty
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid. Desc: -
 *
 * reschedule - Type: bool. Desc: {F = all reschedule disables or empty state; T = at least one reschedule}
 *
 * tabName - Type: string. Desc: {upcoming, history}
 *
 * visitor_id - Type: guid. Desc: -
 * @param {bookingsMemberAreaListUploadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsMemberAreaListUpload = function (params) {
    return { evid: 562, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsNextOrBookItParams
* @property {boolean} accept_online_bookings - T/F
* @property {string} booked_as - relevant only after the user choose a booking option (pricing plan limited/pricing plan unlimited/single)
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {string} button_name - "book" or "book and pay"
* @property {string} catId - null
* @property {GUID} contactId - null
* @property {string} currency - null
* @property {number} depositAmount - null
* @property {boolean} email_empty - null
* @property {boolean} errorOnStaff - only relevant for mobile flow on the calendar page - when having multiple staff members available and none selected
* @property {boolean} fromWaitlist - if this member is after enroll after joining waitlist
* @property {boolean} is_coupon - only relevant for referral "contact_info": 0- if there is an option to use a coupon but not used. 1 if coupon is applied. null otherwise
* @property {boolean} is_membership - 1 if there is an option to view pricing plans for this service (part of a membership or both)
* @property {boolean} is_over_editor - null
* @property {boolean} is_owner - null
* @property {boolean} isPreview - null
* @property {string} mandatoryFieldsList - mandatory fields list. for referal_info='Payment_Info' only.
* @property {GUID} biToken - null
* @property {boolean} name_empty - null
* @property {number} numOfAvailableSpots - number of spots left for this session when click
* @property {number} numberOfRequiredFields - for referal_info='date&time' only. numbers of fields the UoU needs to fill
* @property {string} offered_as - How is this service offered to uou (single, pricing plan, both)
* @property {string} paymentMethod - null
* @property {boolean} phone_empty - null
* @property {string} platform - null
* @property {number} price - null
* @property {string} price_selection - null
* @property {string} referal_info - date&time,contact_info,payment_info, one_app_group_session_select, one_app_appointment_session_select, one_app_date_time, one_app_agenda
* @property {boolean} reschedule - null
* @property {string} screenName - "session page " or "schedule tab"
* @property {string} selected_plan - Only relevant when there are BOTH options {membership/single session}
* @property {string} serviceId - null
* @property {string} sessionId - -
* @property {GUID} site_member_id - site_member_id - logged user
* @property {boolean} smsNotificationRequest - TRUE if uou sms notification was requested. FALSE if not
* @property {string} type - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Book Flow > Next Or Book It. Evid: 509.
 * Event description: next or book it.

 * accept_online_bookings - Type: bool. Desc: T/F
 *
 * booked_as - Type: string. Desc: relevant only after the user choose a booking option (pricing plan limited/pricing plan unlimited/single)
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * button_name - Type: string. Desc: "book" or "book and pay"
 *
 * catId - Type: string.
 *
 * contactId - Type: guid.
 *
 * currency - Type: string.
 *
 * depositAmount - Type: numeric.
 *
 * email_empty - Type: bool.
 *
 * errorOnStaff - Type: bool. Desc: only relevant for mobile flow on the calendar page - when having multiple staff members available and none selected
 *
 * fromWaitlist - Type: bool. Desc: if this member is after enroll after joining waitlist
 *
 * is_coupon - Type: bool. Desc: only relevant for referral "contact_info": 0- if there is an option to use a coupon but not used. 1 if coupon is applied. null otherwise
 *
 * is_membership - Type: bool. Desc: 1 if there is an option to view pricing plans for this service (part of a membership or both)
 *
 * is_over_editor - Type: bool.
 *
 * is_owner - Type: bool.
 *
 * isPreview - Type: bool.
 *
 * mandatoryFieldsList - Type: string. Desc: mandatory fields list. for referal_info='Payment_Info' only.
 *
 * biToken - Type: guid.
 *
 * name_empty - Type: bool.
 *
 * numOfAvailableSpots - Type: numeric. Desc: number of spots left for this session when click
 *
 * numberOfRequiredFields - Type: numeric. Desc: for referal_info='date&time' only. numbers of fields the UoU needs to fill
 *
 * offered_as - Type: string. Desc: How is this service offered to uou (single, pricing plan, both)
 *
 * paymentMethod - Type: string.
 *
 * phone_empty - Type: bool.
 *
 * platform - Type: string.
 *
 * price - Type: numeric.
 *
 * price_selection - Type: string.
 *
 * referal_info - Type: string. Desc: date&time,contact_info,payment_info, one_app_group_session_select, one_app_appointment_session_select, one_app_date_time, one_app_agenda
 *
 * reschedule - Type: bool.
 *
 * screenName - Type: string. Desc: "session page " or "schedule tab"
 *
 * selected_plan - Type: string. Desc: Only relevant when there are BOTH options {membership/single session}
 *
 * serviceId - Type: string.
 *
 * sessionId - Type: string. Desc: -
 *
 * site_member_id - Type: guid. Desc: site_member_id - logged user
 *
 * smsNotificationRequest - Type: bool. Desc: TRUE if uou sms notification was requested. FALSE if not
 *
 * type - Type: string.
 *
 * visitor_id - Type: guid.
 * @param {bookingsNextOrBookItParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsNextOrBookIt = function (params) {
    return { evid: 509, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsServiceTypeWelcomePageClickedParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} platform - {mobile,pc}
* @property {string} type - {class\ind}
* @property {GUID} visitor_id - null
**/
/**
 * Name: NO DATA - bookings > service type welcome page clicked. Evid: 522.
 * Event description: The visitor received the welcome page where he needs to choose the type of service he wants to book- ind or group. Event sent when clicked (only on group + ind businesses).

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * platform - Type: string. Desc: {mobile,pc}
 *
 * type - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid.
 * @param {bookingsServiceTypeWelcomePageClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsServiceTypeWelcomePageClicked = function (params) {
    return { evid: 522, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsServicePageDrpodownChangeLocationSelectionParams
* @property {string} bookingsPlatform - []
* @property {GUID} businessId - []
* @property {GUID} contactId - null
* @property {boolean} isOwner - []
* @property {GUID} locationGuid - location ID
* @property {GUID} biToken - []
* @property {GUID} visitorId - []
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Service Page > Dropdown Change Location Selection. Evid: 587.
 * Event description: service page - change location in drop down.

 * bookingsPlatform - Type: string. Desc: []
 *
 * businessId - Type: guid. Desc: []
 *
 * contactId - Type: guid.
 *
 * isOwner - Type: bool. Desc: []
 *
 * locationGuid - Type: guid. Desc: location ID
 *
 * biToken - Type: guid. Desc: []
 *
 * visitorId - Type: guid. Desc: []
 *
 * visitor_id - Type: guid.
 * @param {bookingsServicePageDrpodownChangeLocationSelectionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsServicePageDrpodownChangeLocationSelection = function (params) {
    return { evid: 587, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsPaymentsChooseProviderPopupParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {string} catId - null
* @property {GUID} contactId - null
* @property {string} currency - service booked currency
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - null
* @property {number} numParticipants - num participants chosen
* @property {string} options - json that holds all the options
* @property {string} platform - {mobile,pc}
* @property {number} price - Multiplied
* @property {string} price_selection - -
* @property {string} serviceId - -
* @property {string} type - {class\ind}
* @property {GUID} visitor_id - null
**/
/**
 * Name: NO DATA - bookings > payments>choose provider popup. Evid: 525.
 * Event description: payment method selection popup open - sent every time the popup is opened http://prntscr.com/f9cn5w.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * catId - Type: string.
 *
 * contactId - Type: guid.
 *
 * currency - Type: string. Desc: service booked currency
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid.
 *
 * numParticipants - Type: numeric. Desc: num participants chosen
 *
 * options - Type: string. Desc: json that holds all the options
 *
 * platform - Type: string. Desc: {mobile,pc}
 *
 * price - Type: numeric. Desc: Multiplied
 *
 * price_selection - Type: string. Desc: -
 *
 * serviceId - Type: string. Desc: -
 *
 * type - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid.
 * @param {bookingsPaymentsChooseProviderPopupParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsPaymentsChooseProviderPopup = function (params) {
    return { evid: 525, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsClickOnBookAServiceButtonAfterMembershipPaymentParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - business_id
* @property {GUID} contactId - contact_id
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - msid
* @property {GUID} site_member_id - site_member_id - member
* @property {GUID} visitor_id - visitor_id
**/
/**
 * Name: Bookings > UoU > Book Flow > Click On "Book a service" Button After Membership Payment. Evid: 568.
 * Event description: bookings > click on the button after membership payment.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: business_id
 *
 * contactId - Type: guid. Desc: contact_id
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid. Desc: msid
 *
 * site_member_id - Type: guid. Desc: site_member_id - member
 *
 * visitor_id - Type: guid. Desc: visitor_id
 * @param {bookingsClickOnBookAServiceButtonAfterMembershipPaymentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsClickOnBookAServiceButtonAfterMembershipPayment = function (params) {
    return { evid: 568, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsCalendarBookingDetailsLoadParams
* @property {string} bookingId - If reschedule then value is not null
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {string} businessProperties - -
* @property {GUID} contactId - null
* @property {string} defaultDateAtFirstLoad - -
* @property {string} errormessage - {}
* @property {string} selectedFilters - -
* @property {boolean} isPremium - -
* @property {string} layout - weekly, daily_month (monthly)
* @property {string} userMessage - -
* @property {GUID} biToken - null
* @property {string} pageName - -
* @property {string} properties - -
* @property {string} referralInfo - service_list_widget' | 'service_details_widget' | 'members_area_reschedule' | 'members_area_book_again'
* @property {string} selectedDate - default date
* @property {string} selectedRange - selected range shown
* @property {DateTime} selected_month - {}
* @property {string} serviceId - service_id
* @property {string} serviceProperties - -
* @property {string} selectedSlot - null
* @property {string} selectedTimezone - -
* @property {string} triggeredBy - -
* @property {string} serviceType - service type
* @property {string} visibleRange - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > calendar > booking details load. Evid: 598.
 * Event description: booking details load.

 * bookingId - Type: string. Desc: If reschedule then value is not null
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * businessProperties - Type: string. Desc: -
 *
 * contactId - Type: guid.
 *
 * defaultDateAtFirstLoad - Type: string. Desc: -
 *
 * errormessage - Type: string. Desc: {}
 *
 * selectedFilters - Type: string. Desc: -
 *
 * isPremium - Type: bool. Desc: -
 *
 * layout - Type: string. Desc: weekly, daily_month (monthly)
 *
 * userMessage - Type: string. Desc: -
 *
 * biToken - Type: guid.
 *
 * pageName - Type: string. Desc: -
 *
 * properties - Type: string. Desc: -
 *
 * referralInfo - Type: string. Desc: service_list_widget' | 'service_details_widget' | 'members_area_reschedule' | 'members_area_book_again'
 *
 * selectedDate - Type: string. Desc: default date
 *
 * selectedRange - Type: string. Desc: selected range shown
 *
 * selected_month - Type: datetime. Desc: {}
 *
 * serviceId - Type: string. Desc: service_id
 *
 * serviceProperties - Type: string. Desc: -
 *
 * selectedSlot - Type: string.
 *
 * selectedTimezone - Type: string. Desc: -
 *
 * triggeredBy - Type: string. Desc: -
 *
 * serviceType - Type: string. Desc: service type
 *
 * visibleRange - Type: string. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsCalendarBookingDetailsLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsCalendarBookingDetailsLoad = function (params) {
    return { evid: 598, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsPaymentMethodSelectionNextClickedParams
* @property {string} formId - booking_form_id
* @property {string} bookingId - -
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {string} businessProperties - -
* @property {GUID} contactId - null
* @property {string} defaultDateAtFirstLoad - -
* @property {string} errorMessage - -
* @property {string} errorReason - <error reason>
* @property {string} selectedFilters - -
* @property {boolean} isCouponCode - --
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPremium - -
* @property {boolean} isUoUloggedIn - --
* @property {string} userMessage - null
* @property {GUID} biToken - null
* @property {number} numParticipants - --
* @property {string} pageName - -
* @property {string} paymentDetails - {Existing pricing plan/New Pricing Plan/ single}
* @property {number} price - --
* @property {string} properties - -
* @property {string} referralInfo - {calendar, booking form}
* @property {string} selectedDate - -
* @property {string} selectedLocation - --
* @property {string} selectedMonth - -
* @property {string} serviceId - -
* @property {string} servicePaymentOptions - what are this service payment options available
* @property {string} serviceProperties - -
* @property {string} sessionId - --
* @property {boolean} smsNotificationRequest - TRUE if uou sms notification was requested. FALSE if not
* @property {GUID} staffId - staff_id
* @property {string} timeslot - session start time
* @property {string} selectedSlot - -
* @property {string} selectedTimezone - -
* @property {string} type - <service type>
* @property {string} serviceType - -
* @property {string} uouPaymentOptions - What are the payment options the uou owns
* @property {string} visibleRange - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Book Flow > Next Book Click Fail. Evid: 518.
 * Event description: UoU click on "next" in the bookings funnel - but got an error and couldn't continue (e.g., missing field in the form).

 * formId - Type: string. Desc: booking_form_id
 *
 * bookingId - Type: string. Desc: -
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * businessProperties - Type: string. Desc: -
 *
 * contactId - Type: guid.
 *
 * defaultDateAtFirstLoad - Type: string. Desc: -
 *
 * errorMessage - Type: string. Desc: -
 *
 * errorReason - Type: string. Desc: <error reason>
 *
 * selectedFilters - Type: string. Desc: -
 *
 * isCouponCode - Type: bool. Desc: --
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPremium - Type: bool. Desc: -
 *
 * isUoUloggedIn - Type: bool. Desc: --
 *
 * userMessage - Type: string.
 *
 * biToken - Type: guid.
 *
 * numParticipants - Type: numeric. Desc: --
 *
 * pageName - Type: string. Desc: -
 *
 * paymentDetails - Type: string. Desc: {Existing pricing plan/New Pricing Plan/ single}
 *
 * price - Type: numeric. Desc: --
 *
 * properties - Type: string. Desc: -
 *
 * referralInfo - Type: string. Desc: {calendar, booking form}
 *
 * selectedDate - Type: string. Desc: -
 *
 * selectedLocation - Type: string. Desc: --
 *
 * selectedMonth - Type: string. Desc: -
 *
 * serviceId - Type: string. Desc: -
 *
 * servicePaymentOptions - Type: string. Desc: what are this service payment options available
 *
 * serviceProperties - Type: string. Desc: -
 *
 * sessionId - Type: string. Desc: --
 *
 * smsNotificationRequest - Type: bool. Desc: TRUE if uou sms notification was requested. FALSE if not
 *
 * staffId - Type: guid. Desc: staff_id
 *
 * timeslot - Type: string. Desc: session start time
 *
 * selectedSlot - Type: string. Desc: -
 *
 * selectedTimezone - Type: string. Desc: -
 *
 * type - Type: string. Desc: <service type>
 *
 * serviceType - Type: string. Desc: -
 *
 * uouPaymentOptions - Type: string. Desc: What are the payment options the uou owns
 *
 * visibleRange - Type: string. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsPaymentMethodSelectionNextClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsPaymentMethodSelectionNextClicked = function (params) {
    return { evid: 518, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsTimeTableNavigationParams
* @property {string} additionalInfo - date presented
* @property {string} bookingsPlatform - null or new_bookings_platform for new server
* @property {GUID} businessId - business_id
* @property {GUID} contactId - contact_id
* @property {string} direction - {backward,forward}
* @property {boolean} isEmptyState - true  = empty state
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - msid
* @property {string} navType - {day,week}
* @property {string} type - {arrow, date}
* @property {GUID} visitor_id - visitor_id
* @property {string} widget_name - {daily_time_table, weekly_time_table}
**/
/**
 * Name: Bookings > UoU > Calendar > Time Table Navigation. Evid: 579.
 * Event description: Navigating between different days or weeks.
https://prnt.sc/p0r1ux.

 * additionalInfo - Type: string. Desc: date presented
 *
 * bookingsPlatform - Type: string. Desc: null or new_bookings_platform for new server
 *
 * businessId - Type: guid. Desc: business_id
 *
 * contactId - Type: guid. Desc: contact_id
 *
 * direction - Type: string. Desc: {backward,forward}
 *
 * isEmptyState - Type: bool. Desc: true  = empty state
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid. Desc: msid
 *
 * navType - Type: string. Desc: {day,week}
 *
 * type - Type: string. Desc: {arrow, date}
 *
 * visitor_id - Type: guid. Desc: visitor_id
 *
 * widget_name - Type: string. Desc: {daily_time_table, weekly_time_table}
 * @param {bookingsTimeTableNavigationParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsTimeTableNavigation = function (params) {
    return { evid: 579, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsMobileLogParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - businessId
* @property {GUID} contactId - -
* @property {string} message - -
* @property {GUID} biToken - -
* @property {string} severity - error/warning/debug
* @property {GUID} visitorId - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > Mobile Log (event for developers). Evid: 520.
 * Event description: event for mobile developers -  don't delete this event! it's for them.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: businessId
 *
 * contactId - Type: guid. Desc: -
 *
 * message - Type: string. Desc: -
 *
 * biToken - Type: guid. Desc: -
 *
 * severity - Type: string. Desc: error/warning/debug
 *
 * visitorId - Type: guid. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsMobileLogParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsMobileLog = function (params) {
    return { evid: 520, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsNextContactInfoParams
* @property {boolean} address_empty - -
* @property {boolean} apartment_empty - -
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {boolean} city_empty - -
* @property {GUID} contactId - null
* @property {boolean} email_empty - -
* @property {boolean} full_name_empty - -
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - null
* @property {boolean} phone_number_empty - -
* @property {string} platform - {mobile,pc}
* @property {string} type - {class\ind}
* @property {GUID} visitor_id - null
**/
/**
 * Name: NO DATA - bookings > next contact info. Evid: 507.
 * Event description: NEED TO DELETE.

 * address_empty - Type: bool. Desc: -
 *
 * apartment_empty - Type: bool. Desc: -
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * city_empty - Type: bool. Desc: -
 *
 * contactId - Type: guid.
 *
 * email_empty - Type: bool. Desc: -
 *
 * full_name_empty - Type: bool. Desc: -
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid.
 *
 * phone_number_empty - Type: bool. Desc: -
 *
 * platform - Type: string. Desc: {mobile,pc}
 *
 * type - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid.
 * @param {bookingsNextContactInfoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsNextContactInfo = function (params) {
    return { evid: 507, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsTestsExposureEventParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - -
* @property {GUID} contactId - null
* @property {boolean} is_eligible - true/false
* @property {GUID} biToken - -
* @property {string} postreg_category - postreg_category
* @property {string} testName - test name
* @property {string} triggerName - exposure point name
* @property {GUID} uuid - uuid if it's user test, else null
* @property {GUID} visitorId - visitorId if it's uou test, else null
* @property {GUID} visitor_id - null
* @property {string} widget_name - widget_name
**/
/**
 * Name: Bookings > UoU > Tests Exposure Event. Evid: 666.
 * Event description: test exposure event for bookings tests.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid.
 *
 * is_eligible - Type: bool. Desc: true/false
 *
 * biToken - Type: guid. Desc: -
 *
 * postreg_category - Type: string. Desc: postreg_category
 *
 * testName - Type: string. Desc: test name
 *
 * triggerName - Type: string. Desc: exposure point name
 *
 * uuid - Type: guid. Desc: uuid if it's user test, else null
 *
 * visitorId - Type: guid. Desc: visitorId if it's uou test, else null
 *
 * visitor_id - Type: guid.
 *
 * widget_name - Type: string. Desc: widget_name
 * @param {bookingsTestsExposureEventParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsTestsExposureEvent = function (params) {
    return { evid: 666, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsLoginUserAccountAppointmentsRescheduleClickParams
* @property {GUID} appointmentId - appointment rescheduled
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} referralinfo - {upcoming}
* @property {string} serviceid - service rescheduled
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Member Area  > My Bookings > Reschedule Click. Evid: 546.
 * Event description: on the user account (myaccount) page > appointments tab - click on reschedule appointment http://prntscr.com/dq9z2z.

 * appointmentId - Type: guid. Desc: appointment rescheduled
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * referralinfo - Type: string. Desc: {upcoming}
 *
 * serviceid - Type: string. Desc: service rescheduled
 *
 * visitor_id - Type: guid.
 * @param {bookingsLoginUserAccountAppointmentsRescheduleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsLoginUserAccountAppointmentsRescheduleClick = function (params) {
    return { evid: 546, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsBookFlowErrorMessagesParams
* @property {string} bookingId - If not null then reschedule
* @property {string} bookingsPlatform - --
* @property {GUID} businessId - --
* @property {GUID} contactId - --
* @property {string} errorMessage - Slot already taken
* @property {GUID} biToken - --
* @property {string} referralInfo - --
* @property {string} serviceId - service_id
* @property {string} sessionId - -
* @property {string} type - {class\ind}
* @property {GUID} visitor_id - --
**/
/**
 * Name: Bookings > UoU > Book Flow Error Message > Shown. Evid: 621.
 * Event description: error message presented to uou.

 * bookingId - Type: string. Desc: If not null then reschedule
 *
 * bookingsPlatform - Type: string. Desc: --
 *
 * businessId - Type: guid. Desc: --
 *
 * contactId - Type: guid. Desc: --
 *
 * errorMessage - Type: string. Desc: Slot already taken
 *
 * biToken - Type: guid. Desc: --
 *
 * referralInfo - Type: string. Desc: --
 *
 * serviceId - Type: string. Desc: service_id
 *
 * sessionId - Type: string. Desc: -
 *
 * type - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid. Desc: --
 * @param {bookingsBookFlowErrorMessagesParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsBookFlowErrorMessages = function (params) {
    return { evid: 621, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsMembersAreaMyBookingsJoinVcSessionModalParams
* @property {string} bookingsPlatform - -
* @property {GUID} businessId - -
* @property {GUID} contactId - -
* @property {string} current_platform - {ZOOM/CUSTOM}
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - -
* @property {string} selection - {join/copy}
* @property {GUID} session_id - -
* @property {GUID} visitor_id - -
**/
/**
 * Name: Bookings > UoU > Members area (My Bookings) > Join VC Session Modal. Evid: 593.
 * Event description: sent when the member chooses whether to join a vc meeting or copy the vc meeting link.

 * bookingsPlatform - Type: string. Desc: -
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid. Desc: -
 *
 * current_platform - Type: string. Desc: {ZOOM/CUSTOM}
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid. Desc: -
 *
 * selection - Type: string. Desc: {join/copy}
 *
 * session_id - Type: guid. Desc: -
 *
 * visitor_id - Type: guid. Desc: -
 * @param {bookingsMembersAreaMyBookingsJoinVcSessionModalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsMembersAreaMyBookingsJoinVcSessionModal = function (params) {
    return { evid: 593, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsCantBookGroupsMessageParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {string} failReason - array of failures
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} referralInfo - {NULL- service list, service_page}
* @property {string} serviceId - service_id
* @property {string} type - service type
* @property {GUID} visitor_id - null
* @property {string} widget_name - widget phase name
**/
/**
 * Name: Bookings > UoU > Book Flow > Cant Book Groups Message. Evid: 527.
 * Event description: The visitor received the 'Sorry, this service can’t be booked online just yet. Please get in touch' message..

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * failReason - Type: string. Desc: array of failures
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * referralInfo - Type: string. Desc: {NULL- service list, service_page}
 *
 * serviceId - Type: string. Desc: service_id
 *
 * type - Type: string. Desc: service type
 *
 * visitor_id - Type: guid.
 *
 * widget_name - Type: string. Desc: widget phase name
 * @param {bookingsCantBookGroupsMessageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsCantBookGroupsMessage = function (params) {
    return { evid: 527, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsClientVmRequestUouParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {GUID} biToken - null
* @property {string} requestedArea - requested vm {owner,settings,widget}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > client vm request - UoU. Evid: 545.
 * Event description: -.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * biToken - Type: guid.
 *
 * requestedArea - Type: string. Desc: requested vm {owner,settings,widget}
 *
 * visitor_id - Type: guid.
 * @param {bookingsClientVmRequestUouParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsClientVmRequestUou = function (params) {
    return { evid: 545, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsUouBookFlowBookingFormClickNextFailureParams
* @property {string} formId - booking_form_id
* @property {GUID} bookingId - null
* @property {string} bookingsPlatform - bookings_platform
* @property {GUID} businessId - business_id
* @property {GUID} contactId - contact_id
* @property {GUID} couponId - coupon_id if applied
* @property {string} currency - null
* @property {number} depositAmount - deposit_amount if exists
* @property {string} errorReason - null
* @property {boolean} isCouponCode - T/F if the uou applied a coupon
* @property {GUID} memberId - null
* @property {GUID} biToken - msid
* @property {number} numParticipants - null
* @property {number} numberOfFields - total number of fields to fill in the form
* @property {number} numberOfRequiredFields - total number of mandatory fields to fill in the form
* @property {string} paymentDetails - Which payment the uou choose - single session/ buy new pricing plan/ exisint pricing plan (in this case the field will include the pp id)
* @property {number} price - null
* @property {GUID} pricingPlanId - pricing_plan_id
* @property {string} referralinfo - from which page the uou came
* @property {string} selectedLocation - selected_location
* @property {string} selectedPaymentOption - Which payment option the uou choose to pay when pay for a single session
* @property {string} serviceId - null
* @property {string} servicePaymentOptions - what are this service payment options available
* @property {string} sessionId - null
* @property {boolean} smsCapability - T if sms reminder option is available
* @property {boolean} smsNotificationRequest - sms_notification_request
* @property {string} staffId - null
* @property {DateTime} startTime - null
* @property {string} serviceType - null
* @property {string} videoType - if the session is virtual which video type - zoom/custom. null if not
* @property {GUID} visitorId - null
* @property {GUID} visitor_id - visitor_id
**/
/**
 * Name: Bookings > UoU > Booking Form > Click Next Failure. Evid: 665.
 * Event description: When the UOU click next in the booking form (valid since bookings and Ecom integration.).

 * formId - Type: string. Desc: booking_form_id
 *
 * bookingId - Type: guid.
 *
 * bookingsPlatform - Type: string. Desc: bookings_platform
 *
 * businessId - Type: guid. Desc: business_id
 *
 * contactId - Type: guid. Desc: contact_id
 *
 * couponId - Type: guid. Desc: coupon_id if applied
 *
 * currency - Type: string.
 *
 * depositAmount - Type: numeric. Desc: deposit_amount if exists
 *
 * errorReason - Type: string.
 *
 * isCouponCode - Type: bool. Desc: T/F if the uou applied a coupon
 *
 * memberId - Type: guid.
 *
 * biToken - Type: guid. Desc: msid
 *
 * numParticipants - Type: numeric.
 *
 * numberOfFields - Type: numeric. Desc: total number of fields to fill in the form
 *
 * numberOfRequiredFields - Type: numeric. Desc: total number of mandatory fields to fill in the form
 *
 * paymentDetails - Type: string. Desc: Which payment the uou choose - single session/ buy new pricing plan/ exisint pricing plan (in this case the field will include the pp id)
 *
 * price - Type: numeric.
 *
 * pricingPlanId - Type: guid. Desc: pricing_plan_id
 *
 * referralinfo - Type: string. Desc: from which page the uou came
 *
 * selectedLocation - Type: string. Desc: selected_location
 *
 * selectedPaymentOption - Type: string. Desc: Which payment option the uou choose to pay when pay for a single session
 *
 * serviceId - Type: string.
 *
 * servicePaymentOptions - Type: string. Desc: what are this service payment options available
 *
 * sessionId - Type: string.
 *
 * smsCapability - Type: bool. Desc: T if sms reminder option is available
 *
 * smsNotificationRequest - Type: bool. Desc: sms_notification_request
 *
 * staffId - Type: string.
 *
 * startTime - Type: datetime.
 *
 * serviceType - Type: string.
 *
 * videoType - Type: string. Desc: if the session is virtual which video type - zoom/custom. null if not
 *
 * visitorId - Type: guid.
 *
 * visitor_id - Type: guid. Desc: visitor_id
 * @param {bookingsUouBookFlowBookingFormClickNextFailureParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsUouBookFlowBookingFormClickNextFailure = function (params) {
    return { evid: 665, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsUouConnectPaymentProviderOnPreviewPopupParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - -
* @property {GUID} contactId - null
* @property {boolean} isPreview - null
* @property {GUID} biToken - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU >  Connect Payment Provider On Preview Popup. Evid: 564.
 * Event description: popup appears - http://prntscr.com/gbmeky.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid.
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsUouConnectPaymentProviderOnPreviewPopupParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsUouConnectPaymentProviderOnPreviewPopup = function (params) {
    return { evid: 564, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsChangeParticipantsQuantityParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {number} numParticipants - -
* @property {string} serviceId - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Form > Change Participants Quantity. Evid: 533.
 * Event description: change participants quantity in the visitor info page  - sent only when changed previous selection
http://prntscr.com/bjzc2t.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * numParticipants - Type: numeric. Desc: -
 *
 * serviceId - Type: string. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsChangeParticipantsQuantityParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsChangeParticipantsQuantity = function (params) {
    return { evid: 533, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsSessionPageContactClickParams
* @property {string} bookingsPlatform - --
* @property {GUID} businessId - --
* @property {GUID} contactId - --
* @property {GUID} biToken - --
* @property {string} referralInfo - one_app_group_session_select,one_app_course_session_select
* @property {string} serviceid - service rescheduled
* @property {string} session_id - --
* @property {string} type - Service type {appointment, class, course}
* @property {GUID} visitor_id - --
**/
/**
 * Name: Bookings > UoU > Session Page Contact Button > Click. Evid: 620.
 * Event description: when price > 0 and there is a zoom link - "contact" button will appear. This event is sent when click..

 * bookingsPlatform - Type: string. Desc: --
 *
 * businessId - Type: guid. Desc: --
 *
 * contactId - Type: guid. Desc: --
 *
 * biToken - Type: guid. Desc: --
 *
 * referralInfo - Type: string. Desc: one_app_group_session_select,one_app_course_session_select
 *
 * serviceid - Type: string. Desc: service rescheduled
 *
 * session_id - Type: string. Desc: --
 *
 * type - Type: string. Desc: Service type {appointment, class, course}
 *
 * visitor_id - Type: guid. Desc: --
 * @param {bookingsSessionPageContactClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsSessionPageContactClick = function (params) {
    return { evid: 620, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsUouQuickBookSelectDateTimeParams
* @property {string} availableSlots - {all available slots}
* @property {string} bookingsPlatform - -
* @property {GUID} businessId - -
* @property {GUID} contactId - -
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - -
* @property {GUID} biToken - -
* @property {string} selectedValue - date / time selected
* @property {string} selectionType - dropdown_date / dropdown_time / select_date / select_time
* @property {string} serviceId - -
* @property {GUID} visitor_id - -
**/
/**
 * Name: Bookings > UoU > Quick Book > Select date / time. Evid: 534.
 * Event description: select date and time on the quick book widget - 4 clicks {dropdown_date / dropdown_time / select_date / select_time}.

 * availableSlots - Type: string. Desc: {all available slots}
 *
 * bookingsPlatform - Type: string. Desc: -
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid. Desc: -
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool. Desc: -
 *
 * biToken - Type: guid. Desc: -
 *
 * selectedValue - Type: string. Desc: date / time selected
 *
 * selectionType - Type: string. Desc: dropdown_date / dropdown_time / select_date / select_time
 *
 * serviceId - Type: string. Desc: -
 *
 * visitor_id - Type: guid. Desc: -
 * @param {bookingsUouQuickBookSelectDateTimeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsUouQuickBookSelectDateTime = function (params) {
    return { evid: 534, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsUouBookingsSummaryChooseNumberOfParticipantsParams
* @property {string} bookingsPlatform - -
* @property {GUID} businessId - -
* @property {GUID} contactId - -
* @property {GUID} biToken - msid
* @property {string} serviceId - -
* @property {string} sessionId - -
* @property {GUID} visitor_id - -
**/
/**
 * Name: Bookings > UoU > bookings_summary > number_of_participants_dropdown_click. Evid: 1051.
 * Event description: when the uou chooses a number of participants on the bookings summary page..

 * bookingsPlatform - Type: string. Desc: -
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid. Desc: -
 *
 * biToken - Type: guid. Desc: msid
 *
 * serviceId - Type: string. Desc: -
 *
 * sessionId - Type: string. Desc: -
 *
 * visitor_id - Type: guid. Desc: -
 * @param {bookingsUouBookingsSummaryChooseNumberOfParticipantsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsUouBookingsSummaryChooseNumberOfParticipants = function (params) {
    return { evid: 1051, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsSaveAnotherParticipantPhase2Params
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - null
* @property {number} numParticipants - beside this one
* @property {string} saveType - {new, edit}
* @property {string} serviceId - -
* @property {boolean} success - T=success, F= fail
* @property {GUID} visitor_id - null
**/
/**
 * Name: NO DATA - bookings > save another participant - phase 2. Evid: 535.
 * Event description: click on save when adding another participants
http://prntscr.com/bjzeny.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid.
 *
 * numParticipants - Type: numeric. Desc: beside this one
 *
 * saveType - Type: string. Desc: {new, edit}
 *
 * serviceId - Type: string. Desc: -
 *
 * success - Type: bool. Desc: T=success, F= fail
 *
 * visitor_id - Type: guid.
 * @param {bookingsSaveAnotherParticipantPhase2Params} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsSaveAnotherParticipantPhase2 = function (params) {
    return { evid: 535, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsSwitchServiceTypeClickedParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - null
* @property {string} platform - {mobile,pc}
* @property {string} switchToType - {class\ind}
* @property {GUID} visitor_id - null
**/
/**
 * Name: NO DATA - bookings > switch service type clicked. Evid: 523.
 * Event description: Click on the button on the top right- switch service type (only on group + ind businesses)..

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid.
 *
 * platform - Type: string. Desc: {mobile,pc}
 *
 * switchToType - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid.
 * @param {bookingsSwitchServiceTypeClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsSwitchServiceTypeClicked = function (params) {
    return { evid: 523, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsTimeZoneShowParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} serviceId - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Time Zone Popup Open. Evid: 539.
 * Event description: open time zone popup  -http://prntscr.com/c781mm.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * serviceId - Type: string. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsTimeZoneShowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsTimeZoneShow = function (params) {
    return { evid: 539, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsSelectPricingPlanParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - business_id
* @property {string} catId - category id
* @property {GUID} contactId - contact_id
* @property {string} currency - currency
* @property {boolean} is_over_editor - is_over_editor
* @property {boolean} is_owner - is_owner
* @property {GUID} biToken - msid
* @property {GUID} paid_plan_id - paid_plan_id
* @property {string} paid_plan_name - paid_plan_name
* @property {number} paid_plan_price - paid_plan_price
* @property {string} paid_plan_valid_for - paid_plan_valid_for (3/4/5 months/1 year/custom)
* @property {string} paymentMethod - payment_type
* @property {string} platform - platform
* @property {string} referal_info - referal_info
* @property {string} serviceId - service_id
* @property {GUID} site_member_id - site_member_id - logged user
* @property {GUID} visitor_id - visitor_id
**/
/**
 * Name: Bookings > UoU > select pricing plan. Evid: 566.
 * Event description: select pricing plan.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: business_id
 *
 * catId - Type: string. Desc: category id
 *
 * contactId - Type: guid. Desc: contact_id
 *
 * currency - Type: string. Desc: currency
 *
 * is_over_editor - Type: bool. Desc: is_over_editor
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * biToken - Type: guid. Desc: msid
 *
 * paid_plan_id - Type: guid. Desc: paid_plan_id
 *
 * paid_plan_name - Type: string. Desc: paid_plan_name
 *
 * paid_plan_price - Type: numeric. Desc: paid_plan_price
 *
 * paid_plan_valid_for - Type: string. Desc: paid_plan_valid_for (3/4/5 months/1 year/custom)
 *
 * paymentMethod - Type: string. Desc: payment_type
 *
 * platform - Type: string. Desc: platform
 *
 * referal_info - Type: string. Desc: referal_info
 *
 * serviceId - Type: string. Desc: service_id
 *
 * site_member_id - Type: guid. Desc: site_member_id - logged user
 *
 * visitor_id - Type: guid. Desc: visitor_id
 * @param {bookingsSelectPricingPlanParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsSelectPricingPlan = function (params) {
    return { evid: 566, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsPaymentsCashierChoosePaymentMethodPopupParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {GUID} biToken - null
* @property {string} serviceId - -
* @property {string} type - {class\ind}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU >  payments> Cashier>choose payment method popup. Evid: 554.
 * Event description: http://prntscr.com/ehvti0.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * biToken - Type: guid.
 *
 * serviceId - Type: string. Desc: -
 *
 * type - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid.
 * @param {bookingsPaymentsCashierChoosePaymentMethodPopupParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsPaymentsCashierChoosePaymentMethodPopup = function (params) {
    return { evid: 554, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsCalendarDrpodownChangeLocationSelectionParams
* @property {string} bookingsPlatform - []
* @property {GUID} businessId - []
* @property {GUID} contactId - []
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - true if is owner
* @property {boolean} isPreview - []
* @property {GUID} locationGuid - location id chosen
* @property {GUID} biToken - []
* @property {GUID} visitor_id - []
**/
/**
 * Name: Bookings > UoU > Calendar > Dropdown Change Location Selection. Evid: 586.
 * Event description: uou chose location to view from dropdown in calndar.

 * bookingsPlatform - Type: string. Desc: []
 *
 * businessId - Type: guid. Desc: []
 *
 * contactId - Type: guid. Desc: []
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: true if is owner
 *
 * isPreview - Type: bool. Desc: []
 *
 * locationGuid - Type: guid. Desc: location id chosen
 *
 * biToken - Type: guid. Desc: []
 *
 * visitor_id - Type: guid. Desc: []
 * @param {bookingsCalendarDrpodownChangeLocationSelectionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsCalendarDrpodownChangeLocationSelection = function (params) {
    return { evid: 586, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsMemberMobileAppBookingSummaryPageBookPayClickParams
* @property {string} answers - please give me the fields name and the answers
* @property {string} bookingsPlatform - null
* @property {string} serviceType - class\course\appointment
* @property {GUID} businessId - null
* @property {string} continueButtonType - choose payment/ join to waitlist /book
* @property {GUID} contactId - null
* @property {string} formType - default \ custom
* @property {string} logged_session_uuid - -
* @property {GUID} biToken - -
* @property {number} numAllFields - how many fields there are in this form? (checkbox, paragraph...)
* @property {number} numCheckbox - how many of the fields are  checkbox type?
* @property {number} numFullFields - number of filled that filled by the member
* @property {number} numNotRequiredFileds - how many of the fields are  not required?
* @property {number} numParaAnswers - how many of the fields are  paraghraph type?
* @property {number} numRequiredFileds - how many of the fields are required?
* @property {number} numShortAnswers - how many of the fields are  short type?
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > Member Mobile App > Booking summary page > Continue button click. Evid: 1028.
 * Event description: when members book a session and are on the booking summary page and click "Book & pay" or other continue buttion.

 * answers - Type: string. Desc: please give me the fields name and the answers
 *
 * bookingsPlatform - Type: string.
 *
 * serviceType - Type: string. Desc: class\course\appointment
 *
 * businessId - Type: guid.
 *
 * continueButtonType - Type: string. Desc: choose payment/ join to waitlist /book
 *
 * contactId - Type: guid.
 *
 * formType - Type: string. Desc: default \ custom
 *
 * logged_session_uuid - Type: string. Desc: -
 *
 * biToken - Type: guid. Desc: -
 *
 * numAllFields - Type: numeric. Desc: how many fields there are in this form? (checkbox, paragraph...)
 *
 * numCheckbox - Type: numeric. Desc: how many of the fields are  checkbox type?
 *
 * numFullFields - Type: numeric. Desc: number of filled that filled by the member
 *
 * numNotRequiredFileds - Type: numeric. Desc: how many of the fields are  not required?
 *
 * numParaAnswers - Type: numeric. Desc: how many of the fields are  paraghraph type?
 *
 * numRequiredFileds - Type: numeric. Desc: how many of the fields are required?
 *
 * numShortAnswers - Type: numeric. Desc: how many of the fields are  short type?
 *
 * visitor_id - Type: guid.
 * @param {bookingsMemberMobileAppBookingSummaryPageBookPayClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsMemberMobileAppBookingSummaryPageBookPayClick = function (params) {
    return { evid: 1028, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsTimeZoneInfoParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} ownerOffset - -
* @property {string} ownerTimeZone - -
* @property {GUID} visitor_id - null
* @property {string} visitorOffset - -
* @property {string} visitorTimeZone - -
**/
/**
 * Name: Bookings > UoU >  Calendar > Time Zone Info Sent. Evid: 532.
 * Event description: sends time zone information when calendar page is opened.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * ownerOffset - Type: string. Desc: -
 *
 * ownerTimeZone - Type: string. Desc: -
 *
 * visitor_id - Type: guid.
 *
 * visitorOffset - Type: string. Desc: -
 *
 * visitorTimeZone - Type: string. Desc: -
 * @param {bookingsTimeZoneInfoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsTimeZoneInfo = function (params) {
    return { evid: 532, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsCalendarClickParams
* @property {string} bookingId - If not null then reschedule
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {string} businessProperties - business properties
* @property {string} component - -
* @property {GUID} contactId - null
* @property {string} defaultDateAtFirstLoad - -
* @property {string} element - -
* @property {string} selectedFilters - filters
* @property {boolean} isPremium - T/F
* @property {string} layout - weekly, daily_month (monthly), 3_day(mobile)
* @property {GUID} biToken - null
* @property {string} pageName - -
* @property {string} priceType - staff/custom
* @property {string} properties - -
* @property {string} referralInfo - referral
* @property {string} selectedDate - default date
* @property {string} selectedRange - selected range shown
* @property {string} serviceId - service_id
* @property {string} serviceProperties - service properties
* @property {string} selectedTimezone - timezone
* @property {string} serviceType - {GROUP/INDIVIDUAL}
* @property {string} visibleRange - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > calendar > click. Evid: 596.
 * Event description: calendar click UoU side.

 * bookingId - Type: string. Desc: If not null then reschedule
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * businessProperties - Type: string. Desc: business properties
 *
 * component - Type: string. Desc: -
 *
 * contactId - Type: guid.
 *
 * defaultDateAtFirstLoad - Type: string. Desc: -
 *
 * element - Type: string. Desc: -
 *
 * selectedFilters - Type: string. Desc: filters
 *
 * isPremium - Type: bool. Desc: T/F
 *
 * layout - Type: string. Desc: weekly, daily_month (monthly), 3_day(mobile)
 *
 * biToken - Type: guid.
 *
 * pageName - Type: string. Desc: -
 *
 * priceType - Type: string. Desc: staff/custom
 *
 * properties - Type: string. Desc: -
 *
 * referralInfo - Type: string. Desc: referral
 *
 * selectedDate - Type: string. Desc: default date
 *
 * selectedRange - Type: string. Desc: selected range shown
 *
 * serviceId - Type: string. Desc: service_id
 *
 * serviceProperties - Type: string. Desc: service properties
 *
 * selectedTimezone - Type: string. Desc: timezone
 *
 * serviceType - Type: string. Desc: {GROUP/INDIVIDUAL}
 *
 * visibleRange - Type: string. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsCalendarClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsCalendarClick = function (params) {
    return { evid: 596, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsAllServicesTabExposureParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - business_id
* @property {boolean} categoryExists - did the uou see 'all services' category
* @property {boolean} category_toggle - is the 'All Services' category toggle on
* @property {GUID} contactId - null
* @property {string} experimentValue - {A,B}
* @property {boolean} isMobile - is it the mobile experience
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - -
* @property {GUID} biToken - null
* @property {GUID} visitorId - visitor_id
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Service List > Load. Evid: 602.
 * Event description: sent when service list is loaded, in order to establish exposure to all services tab test.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: business_id
 *
 * categoryExists - Type: bool. Desc: did the uou see 'all services' category
 *
 * category_toggle - Type: bool. Desc: is the 'All Services' category toggle on
 *
 * contactId - Type: guid.
 *
 * experimentValue - Type: string. Desc: {A,B}
 *
 * isMobile - Type: bool. Desc: is it the mobile experience
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool. Desc: -
 *
 * biToken - Type: guid.
 *
 * visitorId - Type: guid. Desc: visitor_id
 *
 * visitor_id - Type: guid.
 * @param {bookingsAllServicesTabExposureParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsAllServicesTabExposure = function (params) {
    return { evid: 602, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsAnotherAppointmentParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} platform - {mobile,pc}
* @property {string} referralInfo - {upcoming, history, null}
* @property {string} type - {class\ind}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Book Flow > Another Appointment. Evid: 512.
 * Event description: another appointment.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * platform - Type: string. Desc: {mobile,pc}
 *
 * referralInfo - Type: string. Desc: {upcoming, history, null}
 *
 * type - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid.
 * @param {bookingsAnotherAppointmentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsAnotherAppointment = function (params) {
    return { evid: 512, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsCalendarDrpodownChangeStaffMemberSelectionParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Calendar > Dropdown > Change Staff Member Selection. Evid: 529.
 * Event description: sent when the UoU change the dropdown filter selection http://prntscr.com/bgni00.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {bookingsCalendarDrpodownChangeStaffMemberSelectionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsCalendarDrpodownChangeStaffMemberSelection = function (params) {
    return { evid: 529, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsLoginUserAccountPersonalInfoEditClickParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Member Area > personal info> edit.click. Evid: 553.
 * Event description: on the user account (myaccount) page > personal info tab - click on edit http://prntscr.com/e2rey1.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {bookingsLoginUserAccountPersonalInfoEditClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsLoginUserAccountPersonalInfoEditClick = function (params) {
    return { evid: 553, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsUouSessionAddedToCartModalInteractionsParams
* @property {string} actionName - load/go to checkout/add more sessions/close
* @property {string} formId - booking_form_id
* @property {GUID} bookingId - booking_id
* @property {string} bookingsPlatform - bookings_platform
* @property {GUID} businessId - business_id
* @property {GUID} contactId - contact_id
* @property {string} currency - currency
* @property {string} dynamic_price_participants_json - label, amount, num_participants
* @property {GUID} memberId - member_id
* @property {GUID} biToken - msid
* @property {number} numParticipants - num_participants
* @property {string} paymentDetails - Which payment the uou choose - single session/ buy new pricing plan/ exisint pricing plan (in this case the field will include the pp id)
* @property {number} price - price
* @property {string} price_type - label/staff/location
* @property {GUID} pricingPlanId - pricing_plan_id
* @property {string} referralinfo - from which page the uou came
* @property {string} selectedLocation - selected_location
* @property {string} selectedPaymentOption - Which payment option the uou choose for a single session- online/offline
* @property {string} selectedPaymentType - selected_payment_type
* @property {string} serviceId - service_id
* @property {string} servicePaymentOptions - what are this service payment options available
* @property {string} staffId - staff_id
* @property {DateTime} startTime - session start_time
* @property {string} serviceType - service type
* @property {string} videoType - if the session is virtual which video type - zoom/custom. null if not
* @property {GUID} visitorId - visitor_id
* @property {GUID} visitor_id - -
**/
/**
 * Name: Bookings > UoU > Session added to cart modal interactions. Evid: 1072.
 * Event description: When the UOU has interaction with the add to cart modal.

 * actionName - Type: string. Desc: load/go to checkout/add more sessions/close
 *
 * formId - Type: string. Desc: booking_form_id
 *
 * bookingId - Type: guid. Desc: booking_id
 *
 * bookingsPlatform - Type: string. Desc: bookings_platform
 *
 * businessId - Type: guid. Desc: business_id
 *
 * contactId - Type: guid. Desc: contact_id
 *
 * currency - Type: string. Desc: currency
 *
 * dynamic_price_participants_json - Type: string. Desc: label, amount, num_participants
 *
 * memberId - Type: guid. Desc: member_id
 *
 * biToken - Type: guid. Desc: msid
 *
 * numParticipants - Type: numeric. Desc: num_participants
 *
 * paymentDetails - Type: string. Desc: Which payment the uou choose - single session/ buy new pricing plan/ exisint pricing plan (in this case the field will include the pp id)
 *
 * price - Type: numeric. Desc: price
 *
 * price_type - Type: string. Desc: label/staff/location
 *
 * pricingPlanId - Type: guid. Desc: pricing_plan_id
 *
 * referralinfo - Type: string. Desc: from which page the uou came
 *
 * selectedLocation - Type: string. Desc: selected_location
 *
 * selectedPaymentOption - Type: string. Desc: Which payment option the uou choose for a single session- online/offline
 *
 * selectedPaymentType - Type: string. Desc: selected_payment_type
 *
 * serviceId - Type: string. Desc: service_id
 *
 * servicePaymentOptions - Type: string. Desc: what are this service payment options available
 *
 * staffId - Type: string. Desc: staff_id
 *
 * startTime - Type: datetime. Desc: session start_time
 *
 * serviceType - Type: string. Desc: service type
 *
 * videoType - Type: string. Desc: if the session is virtual which video type - zoom/custom. null if not
 *
 * visitorId - Type: guid. Desc: visitor_id
 *
 * visitor_id - Type: guid. Desc: -
 * @param {bookingsUouSessionAddedToCartModalInteractionsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsUouSessionAddedToCartModalInteractions = function (params) {
    return { evid: 1072, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsGoogleCalendarParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} platform - {mobile,pc}
* @property {string} type - {ind,class}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Thank You Page >  Add Booked Service To Google Calendar. Evid: 513.
 * Event description: google calendar.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * platform - Type: string. Desc: {mobile,pc}
 *
 * type - Type: string. Desc: {ind,class}
 *
 * visitor_id - Type: guid.
 * @param {bookingsGoogleCalendarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsGoogleCalendar = function (params) {
    return { evid: 513, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsWaitlistStatusParams
* @property {string} additionalInfo - general description
* @property {string} bookingsPlatform - {mobile, pc}
* @property {GUID} businessId - -
* @property {GUID} contactId - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - -
* @property {GUID} biToken - -
* @property {string} platform - {mobile,pc}
* @property {string} referralInfo - {NULL= regular, widget, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, session page}
* @property {string} service_id - -
* @property {string} sessionId - --
* @property {string} status - join/leave
* @property {string} type - {class\ind}
* @property {GUID} visitor_id - -
**/
/**
 * Name: Bookings > UoU > Book Flow > Join Waitlist Success. Evid: 581.
 * Event description: waitlist status - sent once a user joins or leaves a waiting list - success.

 * additionalInfo - Type: string. Desc: general description
 *
 * bookingsPlatform - Type: string. Desc: {mobile, pc}
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool. Desc: -
 *
 * biToken - Type: guid. Desc: -
 *
 * platform - Type: string. Desc: {mobile,pc}
 *
 * referralInfo - Type: string. Desc: {NULL= regular, widget, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, session page}
 *
 * service_id - Type: string. Desc: -
 *
 * sessionId - Type: string. Desc: --
 *
 * status - Type: string. Desc: join/leave
 *
 * type - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid. Desc: -
 * @param {bookingsWaitlistStatusParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsWaitlistStatus = function (params) {
    return { evid: 581, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsApplyPromoCodeParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - business_id
* @property {GUID} contactId - contact_id
* @property {string} couponId - coupon_id
* @property {string} couponName - coupon code
* @property {string} errorMessage - --
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - is_preview
* @property {GUID} biToken - msid
* @property {string} serviceType - service type {class\ind\course}
* @property {string} valid_value - {ok/expired/invalid/}
* @property {GUID} visitor_id - visitor id
**/
/**
 * Name: Bookings > UoU > Payments > Apply Promo Code. Evid: 572.
 * Event description: Apply promo code after entering it.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: business_id
 *
 * contactId - Type: guid. Desc: contact_id
 *
 * couponId - Type: string. Desc: coupon_id
 *
 * couponName - Type: string. Desc: coupon code
 *
 * errorMessage - Type: string. Desc: --
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool. Desc: is_preview
 *
 * biToken - Type: guid. Desc: msid
 *
 * serviceType - Type: string. Desc: service type {class\ind\course}
 *
 * valid_value - Type: string. Desc: {ok/expired/invalid/}
 *
 * visitor_id - Type: guid. Desc: visitor id
 * @param {bookingsApplyPromoCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsApplyPromoCode = function (params) {
    return { evid: 572, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsBookItClickParams
* @property {boolean} accept_online_bookings - FALSE only if this a "no book flow"
* @property {string} actionName - {navigate_to_contact_form,navigate_to_service_page,open_waiting_list_modal,open_uou_premium_modal,open_owner_premium_modal,navigate_to_specific_page,navigate_to_services_list}
* @property {boolean} bookAnotherLogged - T=http://prntscr.com/dqa17x, NULL/F=regular
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {string} buttonName - the name of the button
* @property {GUID} contactId - null
* @property {boolean} is_membership - 1 if the service is part of membership
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {boolean} isPendingApproval - is_pending_approval indication
* @property {boolean} isPreview - null
* @property {boolean} logged - T= logged in, F= not
* @property {GUID} biToken - null
* @property {string} offered_as - How is this service offered to uou (single, pricing plan, both)
* @property {string} platform - {mobile,pc}
* @property {number} price - Multiplied
* @property {string} referralInfo - {NULL= regular, widget,service page, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, widget_more_info_label,book_button_widget,staff_widget}
* @property {string} screenName - service details and more..
* @property {string} section - -
* @property {string} service_id - -
* @property {string} type - {class\ind}
* @property {GUID} visitor_id - null
* @property {string} widget_name - widget version
**/
/**
 * Name: bookings >  UoU >  "Book It" Click. Evid: 501.
 * Event description: book it click - sent also from image/service name/description/learn more/read more.

 * accept_online_bookings - Type: bool. Desc: FALSE only if this a "no book flow"
 *
 * actionName - Type: string. Desc: {navigate_to_contact_form,navigate_to_service_page,open_waiting_list_modal,open_uou_premium_modal,open_owner_premium_modal,navigate_to_specific_page,navigate_to_services_list}
 *
 * bookAnotherLogged - Type: bool. Desc: T=http://prntscr.com/dqa17x, NULL/F=regular
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * buttonName - Type: string. Desc: the name of the button
 *
 * contactId - Type: guid.
 *
 * is_membership - Type: bool. Desc: 1 if the service is part of membership
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPendingApproval - Type: bool. Desc: is_pending_approval indication
 *
 * isPreview - Type: bool.
 *
 * logged - Type: bool. Desc: T= logged in, F= not
 *
 * biToken - Type: guid.
 *
 * offered_as - Type: string. Desc: How is this service offered to uou (single, pricing plan, both)
 *
 * platform - Type: string. Desc: {mobile,pc}
 *
 * price - Type: numeric. Desc: Multiplied
 *
 * referralInfo - Type: string. Desc: {NULL= regular, widget,service page, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, widget_more_info_label,book_button_widget,staff_widget}
 *
 * screenName - Type: string. Desc: service details and more..
 *
 * section - Type: string. Desc: -
 *
 * service_id - Type: string. Desc: -
 *
 * type - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid.
 *
 * widget_name - Type: string. Desc: widget version
 * @param {bookingsBookItClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsBookItClick = function (params) {
    return { evid: 501, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsChooseTimeSlotParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {boolean} isWaitingList - true/false according to the indicator
* @property {GUID} biToken - null
* @property {string} origin - optional - timetable_widget
* @property {string} platform - {mobile,pc}
* @property {boolean} reschedule - T=is reschedule F= regular
* @property {GUID} staffId - staff_id
* @property {string} type - {class\ind}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Calendar > Choose Time Slot. Evid: 506.
 * Event description: choose time slot.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * isWaitingList - Type: bool. Desc: true/false according to the indicator
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: optional - timetable_widget
 *
 * platform - Type: string. Desc: {mobile,pc}
 *
 * reschedule - Type: bool. Desc: T=is reschedule F= regular
 *
 * staffId - Type: guid. Desc: staff_id
 *
 * type - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid.
 * @param {bookingsChooseTimeSlotParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsChooseTimeSlot = function (params) {
    return { evid: 506, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsAccountActivityUserClickParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} pageName - {service_list, calendar...}
* @property {string} service_id - NOT SENT
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Account Activity > User Click. Evid: 544.
 * Event description: http://prntscr.com/d6ntxz.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * pageName - Type: string. Desc: {service_list, calendar...}
 *
 * service_id - Type: string. Desc: NOT SENT
 *
 * visitor_id - Type: guid.
 * @param {bookingsAccountActivityUserClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsAccountActivityUserClick = function (params) {
    return { evid: 544, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} jsErrorParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: NO DATA - js_error. Evid: 524.
 * Event description: this event is sent every time a java script error occurs- for user explorer research (dev request - Boris).

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {jsErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var jsError = function (params) {
    return { evid: 524, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsChoosePricingMethodClickParams
* @property {string} bookingsPlatform - --
* @property {GUID} businessId - -
* @property {GUID} contactId - --
* @property {GUID} biToken - -
* @property {number} numOfAvailableSpots - number of spots left for this session when click
* @property {GUID} serviceId - service id
* @property {string} sessionId - -
* @property {string} type - service type
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Payments > Choose Pricing Method Click. Evid: 613.
 * Event description: When clicking on choose a pricing method button on session page on spaces.

 * bookingsPlatform - Type: string. Desc: --
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid. Desc: --
 *
 * biToken - Type: guid. Desc: -
 *
 * numOfAvailableSpots - Type: numeric. Desc: number of spots left for this session when click
 *
 * serviceId - Type: guid. Desc: service id
 *
 * sessionId - Type: string. Desc: -
 *
 * type - Type: string. Desc: service type
 *
 * visitor_id - Type: guid.
 * @param {bookingsChoosePricingMethodClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsChoosePricingMethodClick = function (params) {
    return { evid: 613, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsAppointmentBookedServerIssueParams
* @property {string} bookingId - -
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - -
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - -
* @property {string} service - [type of service]
* @property {string} status - {valid, invalid online, invalid offline}
* @property {string} sub_category - [why status fail]
* @property {string} transaction - {book new, reschedule}
* @property {GUID} visitor_id - -
**/
/**
 * Name: Bookings > UoU > appointment booked server issue. Evid: 565.
 * Event description: sent with the appointment booked event to detect failure, if exist.

 * bookingId - Type: string. Desc: -
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid. Desc: -
 *
 * service - Type: string. Desc: [type of service]
 *
 * status - Type: string. Desc: {valid, invalid online, invalid offline}
 *
 * sub_category - Type: string. Desc: [why status fail]
 *
 * transaction - Type: string. Desc: {book new, reschedule}
 *
 * visitor_id - Type: guid. Desc: -
 * @param {bookingsAppointmentBookedServerIssueParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsAppointmentBookedServerIssue = function (params) {
    return { evid: 565, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsUouBookFlowBookingFormClickNextParams
* @property {string} action - choose a plan / add to cart / next
* @property {string} formId - booking_form_id
* @property {GUID} bookingId - booking_id
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - business_id
* @property {GUID} contactId - contact_id
* @property {GUID} couponId - coupon_id if applied
* @property {string} currency - currency
* @property {number} depositAmount - deposit_amount if exists
* @property {string} dynamic_price_participants_json - label, amount, num_participants
* @property {boolean} isCouponCode - T/F if the uou applied a coupon
* @property {GUID} memberId - member_id
* @property {GUID} biToken - msid
* @property {number} numOfOptions - from jason file
* @property {number} numParticipants - null
* @property {number} numberOfFields - total number of fields to fill in the form
* @property {number} numberOfRequiredFields - total number of mandatory fields to fill in the form
* @property {string} paymentDetails - Which payment the uou choose - single session/ buy new pricing plan/ exisint pricing plan (in this case the field will include the pp id)
* @property {number} price - price
* @property {string} price_type - label/staff/location
* @property {GUID} pricingPlanId - null
* @property {string} referralinfo - from which page the uou came
* @property {string} selectedLocation - null
* @property {string} selectedPaymentOption - Which payment option the uou choose for a single session- online/offline
* @property {string} selectedPaymentType - selected_payment_type
* @property {string} serviceId - service_id
* @property {string} servicePaymentOptions - what are this service payment options available
* @property {string} sessionId - session_id
* @property {boolean} smsCapability - T if sms reminder option is available
* @property {boolean} smsNotificationRequest - null
* @property {string} staffId - staff_id
* @property {DateTime} startTime - session start_time
* @property {string} serviceType - null
* @property {string} videoType - if the session is virtual which video type - zoom/custom. null if not
* @property {GUID} visitorId - visitor_id
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Booking Form > Next Click. Evid: 659.
 * Event description: When the UOU click next in the booking form (valid since bookings and Ecom integration.).

 * action - Type: string. Desc: choose a plan / add to cart / next
 *
 * formId - Type: string. Desc: booking_form_id
 *
 * bookingId - Type: guid. Desc: booking_id
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: business_id
 *
 * contactId - Type: guid. Desc: contact_id
 *
 * couponId - Type: guid. Desc: coupon_id if applied
 *
 * currency - Type: string. Desc: currency
 *
 * depositAmount - Type: numeric. Desc: deposit_amount if exists
 *
 * dynamic_price_participants_json - Type: string. Desc: label, amount, num_participants
 *
 * isCouponCode - Type: bool. Desc: T/F if the uou applied a coupon
 *
 * memberId - Type: guid. Desc: member_id
 *
 * biToken - Type: guid. Desc: msid
 *
 * numOfOptions - Type: numeric. Desc: from jason file
 *
 * numParticipants - Type: numeric.
 *
 * numberOfFields - Type: numeric. Desc: total number of fields to fill in the form
 *
 * numberOfRequiredFields - Type: numeric. Desc: total number of mandatory fields to fill in the form
 *
 * paymentDetails - Type: string. Desc: Which payment the uou choose - single session/ buy new pricing plan/ exisint pricing plan (in this case the field will include the pp id)
 *
 * price - Type: numeric. Desc: price
 *
 * price_type - Type: string. Desc: label/staff/location
 *
 * pricingPlanId - Type: guid.
 *
 * referralinfo - Type: string. Desc: from which page the uou came
 *
 * selectedLocation - Type: string.
 *
 * selectedPaymentOption - Type: string. Desc: Which payment option the uou choose for a single session- online/offline
 *
 * selectedPaymentType - Type: string. Desc: selected_payment_type
 *
 * serviceId - Type: string. Desc: service_id
 *
 * servicePaymentOptions - Type: string. Desc: what are this service payment options available
 *
 * sessionId - Type: string. Desc: session_id
 *
 * smsCapability - Type: bool. Desc: T if sms reminder option is available
 *
 * smsNotificationRequest - Type: bool.
 *
 * staffId - Type: string. Desc: staff_id
 *
 * startTime - Type: datetime. Desc: session start_time
 *
 * serviceType - Type: string.
 *
 * videoType - Type: string. Desc: if the session is virtual which video type - zoom/custom. null if not
 *
 * visitorId - Type: guid. Desc: visitor_id
 *
 * visitor_id - Type: guid.
 * @param {bookingsUouBookFlowBookingFormClickNextParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsUouBookFlowBookingFormClickNext = function (params) {
    return { evid: 659, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsCoursePageViewFullScheduleClickParams
* @property {string} bookingsPlatform - new_bookings_platform
* @property {GUID} businessId - -
* @property {GUID} contactId - null
* @property {GUID} biToken - -
* @property {string} origin - member_course_page
* @property {string} serviceId - -
* @property {string} type - course
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > Member Mobile App > OneApp > course page > view full schedule click. Evid: 583.
 * Event description: member - https://zpl.io/aR5MAez.

 * bookingsPlatform - Type: string. Desc: new_bookings_platform
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid.
 *
 * biToken - Type: guid. Desc: -
 *
 * origin - Type: string. Desc: member_course_page
 *
 * serviceId - Type: string. Desc: -
 *
 * type - Type: string. Desc: course
 *
 * visitor_id - Type: guid.
 * @param {bookingsCoursePageViewFullScheduleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsCoursePageViewFullScheduleClick = function (params) {
    return { evid: 583, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsMemberMobileAppClassPageClicksParams
* @property {GUID} bookingId - -
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - -
* @property {GUID} contactId - -
* @property {DateTime} datetime - -
* @property {string} element - the area of the page that the uou choose
* @property {boolean} enterCouponFocus - true if the user started to fill the coupon name
* @property {boolean} isAlreadyBooked - true if the session is already booked
* @property {GUID} logged_in_uuid - -
* @property {string} modalName - relevant for the modals that are opened in this page
* @property {string} modalSelection - the selection in the modal, relevant for the modals that are opened in this page
* @property {GUID} biToken - null
* @property {string} sessionId - -
* @property {number} time - -
* @property {string} type - class
* @property {GUID} visitorId - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > Member Mobile app > Class page > Clicks. Evid: 1021.
 * Event description: when uou went to a class page on the member app and pressed the buttons. this is a generic event for all the clicks inside this page and this page modals.
the previous events were-
16:574 - when  member clicked om 3 dots
16:576 - when member clicked on remove in 3 dots modal
16:572 - when member clicked on apply when edit a coupon.
the rest were missing..

 * bookingId - Type: guid. Desc: -
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid. Desc: -
 *
 * datetime - Type: datetime. Desc: -
 *
 * element - Type: string. Desc: the area of the page that the uou choose
 *
 * enterCouponFocus - Type: bool. Desc: true if the user started to fill the coupon name
 *
 * isAlreadyBooked - Type: bool. Desc: true if the session is already booked
 *
 * logged_in_uuid - Type: guid. Desc: -
 *
 * modalName - Type: string. Desc: relevant for the modals that are opened in this page
 *
 * modalSelection - Type: string. Desc: the selection in the modal, relevant for the modals that are opened in this page
 *
 * biToken - Type: guid.
 *
 * sessionId - Type: string. Desc: -
 *
 * time - Type: numeric. Desc: -
 *
 * type - Type: string. Desc: class
 *
 * visitorId - Type: guid. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsMemberMobileAppClassPageClicksParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsMemberMobileAppClassPageClicks = function (params) {
    return { evid: 1021, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsCalendarFiltersLoadParams
* @property {string} bookingId - If reschedule then value is not null
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {string} businessProperties - -
* @property {GUID} contactId - null
* @property {string} defaultDateAtFirstLoad - -
* @property {string} selectedFilters - -
* @property {boolean} isPremium - -
* @property {string} layout - layout
* @property {GUID} biToken - null
* @property {string} pageName - -
* @property {string} referralInfo - service_list_widget' | 'service_details_widget' | 'members_area_reschedule' | 'members_area_book_again'
* @property {string} selectedDate - default date
* @property {string} serviceId - service_id
* @property {string} serviceProperties - -
* @property {string} selectedTimezone - -
* @property {string} triggeredBy - -
* @property {string} serviceType - service type
* @property {string} visibleRange - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > calendar > filters load. Evid: 599.
 * Event description: filters load / refresh.

 * bookingId - Type: string. Desc: If reschedule then value is not null
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * businessProperties - Type: string. Desc: -
 *
 * contactId - Type: guid.
 *
 * defaultDateAtFirstLoad - Type: string. Desc: -
 *
 * selectedFilters - Type: string. Desc: -
 *
 * isPremium - Type: bool. Desc: -
 *
 * layout - Type: string. Desc: layout
 *
 * biToken - Type: guid.
 *
 * pageName - Type: string. Desc: -
 *
 * referralInfo - Type: string. Desc: service_list_widget' | 'service_details_widget' | 'members_area_reschedule' | 'members_area_book_again'
 *
 * selectedDate - Type: string. Desc: default date
 *
 * serviceId - Type: string. Desc: service_id
 *
 * serviceProperties - Type: string. Desc: -
 *
 * selectedTimezone - Type: string. Desc: -
 *
 * triggeredBy - Type: string. Desc: -
 *
 * serviceType - Type: string. Desc: service type
 *
 * visibleRange - Type: string. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsCalendarFiltersLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsCalendarFiltersLoad = function (params) {
    return { evid: 599, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsFitMemberAppPerformanceWidgetCompleteActionParams
* @property {string} actionName - []
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {GUID} biToken - null
* @property {string} section - []
* @property {string} value - value
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > Member Mobile App > Fit Performance Widget -> Complete Action. Evid: 606.
 * Event description: copleted an action in the performance tracker widget.

 * actionName - Type: string. Desc: []
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * biToken - Type: guid.
 *
 * section - Type: string. Desc: []
 *
 * value - Type: string. Desc: value
 *
 * visitor_id - Type: guid.
 * @param {bookingsFitMemberAppPerformanceWidgetCompleteActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsFitMemberAppPerformanceWidgetCompleteAction = function (params) {
    return { evid: 606, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsFitMemberAppPerformanceWidgetClickOnItemParams
* @property {string} actionName - []
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {GUID} biToken - null
* @property {string} section - []
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > Member Mobile App > Fit Performance Widget item > Click. Evid: 605.
 * Event description: click on any item in performance widget.

 * actionName - Type: string. Desc: []
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * biToken - Type: guid.
 *
 * section - Type: string. Desc: []
 *
 * visitor_id - Type: guid.
 * @param {bookingsFitMemberAppPerformanceWidgetClickOnItemParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsFitMemberAppPerformanceWidgetClickOnItem = function (params) {
    return { evid: 605, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsClickOnWaitlistActionParams
* @property {string} bookingsPlatform - --
* @property {GUID} businessId - -
* @property {GUID} contactId - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - -
* @property {GUID} biToken - -
* @property {string} platform - {mobile,pc}
* @property {string} referralInfo - {NULL= regular, widget, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, session page}
* @property {string} service_id - -
* @property {string} sessionId - --
* @property {string} status - join/leave
* @property {string} type - {class\ind\course}
* @property {GUID} visitor_id - -
**/
/**
 * Name: Bookings > UoU > Waitlist Action > Click. Evid: 619.
 * Event description: click on button to join / cancel waitlist, success event 16:581.

 * bookingsPlatform - Type: string. Desc: --
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool. Desc: -
 *
 * biToken - Type: guid. Desc: -
 *
 * platform - Type: string. Desc: {mobile,pc}
 *
 * referralInfo - Type: string. Desc: {NULL= regular, widget, members_area_upcoming, members_area_history, one_app_main_tab, one_app_all_classes, one_app_all_appointments, one_app_agenda, session page}
 *
 * service_id - Type: string. Desc: -
 *
 * sessionId - Type: string. Desc: --
 *
 * status - Type: string. Desc: join/leave
 *
 * type - Type: string. Desc: {class\ind\course}
 *
 * visitor_id - Type: guid. Desc: -
 * @param {bookingsClickOnWaitlistActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsClickOnWaitlistAction = function (params) {
    return { evid: 619, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsMemberLoginSignoutClickParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} pageName - {service_list,calendar,personal_info...}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Member Area > Signout Click. Evid: 552.
 * Event description: click on signout.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * pageName - Type: string. Desc: {service_list,calendar,personal_info...}
 *
 * visitor_id - Type: guid.
 * @param {bookingsMemberLoginSignoutClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsMemberLoginSignoutClick = function (params) {
    return { evid: 552, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsChangeTimeZoneClickedParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {string} changeTo - {local,business time zone}
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - editor or viewer
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} referralInfo - {calendar,offering_page, service_page}
* @property {string} serviceId - -
* @property {string} timezone - -
* @property {string} type - {class\ind\course}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Calendar > Change Time Zone Clicked. Evid: 538.
 * Event description: convert time zone- http://prntscr.com/c780rd.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * changeTo - Type: string. Desc: {local,business time zone}
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: editor or viewer
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * referralInfo - Type: string. Desc: {calendar,offering_page, service_page}
 *
 * serviceId - Type: string. Desc: -
 *
 * timezone - Type: string. Desc: -
 *
 * type - Type: string. Desc: {class\ind\course}
 *
 * visitor_id - Type: guid.
 * @param {bookingsChangeTimeZoneClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsChangeTimeZoneClicked = function (params) {
    return { evid: 538, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsLoginUserAccountAppointmentsMoreDetailsServiceClickParams
* @property {string} appointmentId - appointment more info
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - -
* @property {GUID} contactId - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPendingApproval - T/F for pending approval service
* @property {GUID} biToken - -
* @property {string} referralinfo - {upcoming, history}
* @property {string} serviceid - service more info
* @property {string} sessionId - -
* @property {GUID} visitor_id - -
**/
/**
 * Name: Bookings > Member Mobile App > My Bookings > More Details Service Click. Evid: 561.
 * Event description: on the user account (members area - my bookings) page > upcoming/history tab - click on service line https://prnt.sc/gscdqf.

 * appointmentId - Type: string. Desc: appointment more info
 *
 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid. Desc: -
 *
 * contactId - Type: guid. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPendingApproval - Type: bool. Desc: T/F for pending approval service
 *
 * biToken - Type: guid. Desc: -
 *
 * referralinfo - Type: string. Desc: {upcoming, history}
 *
 * serviceid - Type: string. Desc: service more info
 *
 * sessionId - Type: string. Desc: -
 *
 * visitor_id - Type: guid. Desc: -
 * @param {bookingsLoginUserAccountAppointmentsMoreDetailsServiceClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsLoginUserAccountAppointmentsMoreDetailsServiceClick = function (params) {
    return { evid: 561, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsFitMemberAppPerformanceWidgetLoadedParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {GUID} biToken - null
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > Member Mobile App > Fit Performance Widget -> Load. Evid: 604.
 * Event description: performance tracker widget loaded.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * biToken - Type: guid.
 *
 * visitor_id - Type: guid.
 * @param {bookingsFitMemberAppPerformanceWidgetLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsFitMemberAppPerformanceWidgetLoaded = function (params) {
    return { evid: 604, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsMoreParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} service_id - -
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > more - No Data. Evid: 502.
 * Event description: Cancelled.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * service_id - Type: string. Desc: -
 *
 * visitor_id - Type: guid.
 * @param {bookingsMoreParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsMore = function (params) {
    return { evid: 502, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsCancelOrBackParams
* @property {string} bookingsPlatform - null
* @property {GUID} businessId - null
* @property {GUID} contactId - null
* @property {boolean} is_over_editor - -
* @property {boolean} is_owner - is_owner
* @property {boolean} isPreview - null
* @property {GUID} biToken - null
* @property {string} platform - {mobile,pc}
* @property {string} referal_info - {date&time, contact_info,Confirmation}
* @property {string} type - {class\ind}
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Book Flow > Cancel or Back. Evid: 510.
 * Event description: cancel or back.

 * bookingsPlatform - Type: string.
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid.
 *
 * is_over_editor - Type: bool. Desc: -
 *
 * is_owner - Type: bool. Desc: is_owner
 *
 * isPreview - Type: bool.
 *
 * biToken - Type: guid.
 *
 * platform - Type: string. Desc: {mobile,pc}
 *
 * referal_info - Type: string. Desc: {date&time, contact_info,Confirmation}
 *
 * type - Type: string. Desc: {class\ind}
 *
 * visitor_id - Type: guid.
 * @param {bookingsCancelOrBackParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsCancelOrBack = function (params) {
    return { evid: 510, src: 16, endpoint: 'wixboost-ugc', params: params };
};
/**
* @typedef {Object} bookingsBookingsFormLoadParams
* @property {string} formId - --
* @property {string} bookingsPlatform - -
* @property {GUID} businessId - null
* @property {GUID} contactId - -
* @property {GUID} biToken - null
* @property {string} referralInfo - -
* @property {string} serviceId - service id
* @property {GUID} visitor_id - null
**/
/**
 * Name: Bookings > UoU > Bookings Form > Load. Evid: 636.


 * formId - Type: string. Desc: --
 *
 * bookingsPlatform - Type: string. Desc: -
 *
 * businessId - Type: guid.
 *
 * contactId - Type: guid. Desc: -
 *
 * biToken - Type: guid.
 *
 * referralInfo - Type: string. Desc: -
 *
 * serviceId - Type: string. Desc: service id
 *
 * visitor_id - Type: guid.
 * @param {bookingsBookingsFormLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bookingsBookingsFormLoad = function (params) {
    return { evid: 636, src: 16, endpoint: 'wixboost-ugc', params: params };
};
//# sourceMappingURL=index.js.map